import Swiper from 'swiper/bundle';
import moment from 'moment';
import flatpickr from "flatpickr";
import {sendTag, sendTagGoogleSubmit} from "./tag-managers.es6";
import { DotLottie } from '@lottiefiles/dotlottie-web';

const swiperContainer = ".multistep-slider.swiper-container";
const sectionAccordion = $('.section-accordion');
export const swiperMultistep = new Swiper(swiperContainer, {
    slidesPerView: 1,
    loop: false,
    autoHeight: true,
    spaceBetween: 20,
    allowTouchMove: false,
    allowSlidePrev: false,
    allowSlideNext: false,
    on: {
        slideChange: function () {
            swiperMultistep.updateAutoHeight();
            let currentIndex = swiperMultistep.realIndex;
            let totalSlides = swiperMultistep.slides.length;
            let nextCurrentIndex = currentIndex + 2;

            if (sectionAccordion.length > 0) {
                if (currentIndex === totalSlides - 1) {
                    sectionAccordion.slideDown();
                } else {
                    sectionAccordion.slideUp();
                }
            }

            if ($('.step-link').length > 0) {
                $('.step-link').removeClass('ready-to-click');
                $('.step-parent:lt(' + nextCurrentIndex + ') .step-link').addClass('ready-to-click');
            }
        },
        init: function () {

            if ($('.step-link').length > 0) {
                $('.step-parent:lt(' + 2 + ') .step-link').addClass('ready-to-click');
            }

        }
    }
});


//Api Class
// Page URLs
const FORM_URL = $('.multi-step_form_preview .form-box').data('redirect-url') || '/multistep-form';
const TEST_URL = '/sofortsparen';
const TEST_URL_STROMSTEUER = '/stromsteuer';
const BUSINESS_PRODUKTAUSWAHL_URL = '/business/produktauswahl/';

// Privatkunden product calculator consumption thresholds (Jira "product calculator & nav bar").
const CONSUMPTION_THRESHOLD_POPUP_1 = 10000; // > this and <= POPUP_2 -> ask private/business (popup 1)
const CONSUMPTION_THRESHOLD_POPUP_2 = 20000; // > this and <= MAX -> confirm business (popup 2)
const CONSUMPTION_THRESHOLD_MAX = 100000; // > this -> reject, no calculation

// Frontend-only isPrivateCustomer handoff marker (see sendDataAndRedirect / FakeFindTariff below),
// captured once here at script-load time - checkAndSubmitFormData() in
// section_multi-step_form_preview.es6 strips postalcode/city/consumption/isPrivateCustomer from
// the URL via history.replaceState before it auto-submits the real .find-tariff form, so a live
// read of window.location.search from inside the nfFormSubmitResponse handler below would always
// come back empty by the time it runs.
const INCOMING_PRIVATE_CUSTOMER_MARKER = (function () {
    try {
        const value = new URLSearchParams(window.location.search).get('isPrivateCustomer');
        return value === '1' || value === 'true';
    } catch (e) {
        return false;
    }
})();

function normalizeUrl(url) {
    if (!url || typeof url !== 'string') {
        return '';
    }

    try {
        return new URL(url, window.location.origin).toString();
    } catch (e) {
        return '';
    }
}

function getTariffMultistepUrlFromNinjaResponse(response) {
    const rr = response && response.response;
    const data = rr && rr.data;
    const actions = data && data.actions;

    if (!actions) {
        return '';
    }

    if (actions.tariff_multistep_url && actions.tariff_multistep_url.url) {
        return normalizeUrl(actions.tariff_multistep_url.url);
    }

    const actionList = Array.isArray(actions) ? actions : Object.values(actions);

    for (const action of actionList) {
        if (!action) {
            continue;
        }

        const settings = action.settings || {};

        const actionName =
            action.name ||
            action.type ||
            action.action_type ||
            settings.name ||
            settings.type;

        const url =
            action.url ||
            action.tariff_multistep_url ||
            settings.url ||
            settings.tariff_multistep_url;

        if (actionName === 'tariff_multistep_url' && url) {
            return normalizeUrl(url);
        }
    }

    return '';
}

// Selectors
const SELECTORS = {
    POSTAL_CODE_AND_ORT_SELECT: '.find-tariff select[name="postalcode_ort"]',
    POSTAL_CODE_AND_ORT_SELECT_SELECT2_TEXTAREA: '.find-tariff [name="postalcode_ort"] + .select2-container .select2-search__field',
    CONSUMPTION_INPUT: '.find-tariff input[name="consumption"]',
    STREET_INPUT_FAKE: '.street-popup select[name="first_step_street"]',
    HOUSE_NUMBER_INPUT_FAKE: '.street-popup input[name="housenumber"]',
    SECRET_KEY_INPUT: 'input[name="secret_key"]',
    REFERRAL_CONTRACT_NUMBER: 'input[name="referral_contract_number"]',
    HIDDEN_SECRET_KEY_INPUT: 'input#hiddenSecretKey',
    HIDDEN_REFERRAL_CONTRACT_NUMBER: 'input#hiddenReferralContractNumber',
    FIND_TARIFF_FORM: '.find-tariff form',
    STEP_POSTAL_CODE: 'input[name="postalCode"]',
    STEP_D_POSTAL_CODE: 'input[name="dpostalCode"]',
    HOUSE_NUMBER_INPUT: 'input[name="housenumber"]',
    PAYMENT_TYPE_RADIO: 'input[name="paymentType"]',
    MARKET_LOCATION_INPUT: 'input[name="marketLocation"]',
    DELIVERY_POINT_METERING_DEVICE_NUMBER_INPUT: 'input[name="deliveryPointMeteringDeviceNumber"]',
    PAYMENT_TYPE_RADIO_CHECKED: 'input[name="paymentType"]:checked',
    STREET: 'select[name=street]',
    D_STREET: 'select[name=dstreet]',
    D_CITY: 'input[name="dcity"]',
    D_HOUSE_NUMBER: 'input[name="dhousenumber"]',
    D_HOUSE_NUMBER_ADDITION: 'input[name="dhousenumberAddition"]',
    D_POSTAL_CODE_AND_ORT_SELECT: '.d-postalcode-ort-select',
    D_LEGAL_FORM: 'select[name="dlegalForm"]',
    SEND_DATA_FORM: '.multistep-data form',
    FAKE_FIND_TARIFF_FORM: '.fake-find-tariff form',
    DIRECT_DEBIT_APPROVE: 'input[name="directDebitApprove"]',
    PRICE_INFO_CONTAINER_WRAPPER: '#price-info-container-wrapper',
    RESULT_TARIFF: '.result-tariff',
    PRICE_INFO_CONTAINER: '#price-info-container',
    TARIF_FORM: '#tariff-form',
    CHOOSE_TARIFF_BTN: '#choose-tariff-btn',
    ERROR_MESSAGE: '.error-message',
    DIFFERENT_ADDRESS_CHECKBOX: 'input[name="differentAddress"]',
    DIFFERENT_INVOICE_EMAIL_CHECKBOX: 'input[name="differentInvoiceEmail"]',
    INVOICE_EMAIL_INPUT: 'input[name="invoiceEmail"]',
    FAKE_INVOICE_EMAIL_INPUT: 'input[name="fakeInvoiceEmail"]',
    OLD_SUPPLIER_CANCELLATION_STATE_RADIO: 'input[name="oldSupplierCancellationState"]:checked, input[name="oldSupplierCancellationState-copy"]:checked',
    SUPPLY_BEGIN_DATE_SPECIFIED_RADIO: 'input[name="supplyBeginDateSpecified"]:checked, input[name="supplyBeginDateSpecified-copy"]:checked',
    HIDDEN_CITY: '#hiddenCity',
    HIDDEN_TARIFF_ID: '#hiddenTariffId',
    HIDDEN_CONSUMPTION: '#hiddenConsumption',
    SUPPLY_CHANGE_CAUSE: 'input[name="supplyChangeCause"]:checked',
    HIDDEN_POSTAL_CODE: '#hiddenPostalCode',
    HIDDEN_STREET: '#hiddenStreet',
    HIDDEN_HOUSE_NUMBER: '#hiddenHouseNumber',
    OLD_SUPPLIER_NAME: '[name="oldSupplier"]',
    LOADER: '#loader',
    BANK_NAME_INPUT: 'input[name="bankName"]',
    BANK_ACCOUNT_IBAN_INPUT: 'input[name="bankAccountIban"]',
    BANK_ACCOUNT_OWNER_NAME: '[name="bankAccountOwnerName"]',
    IBAN_INPUT: 'input[name="bankAccountIban"]',
    COLLECTED_INFO_WRAP_STEP4: '.swiper-slide.-step4',
    SWIPER_CONTAINER: ".multistep-slider.swiper-container",
    APPROVE_EMAIL_NOTIFICATION: 'input[name="approveEmailNotification"]',
    MULTISTEP_TARIFF_FORM_WRAP: '.multi-step_form_preview.tariff-api',
    STREET_POPUP: '.street-popup',
    STREET_POPUP_FORM: '.street-popup #street-form-fake',
    ERROR_NAME_BANK: '.error-name-bank',
    CONTAINER_BANK_NAME: '.bank-name-container',
    AI_BLOCK: '.ai-text-box'
};

const ratingMapping = {
    'K':'R5',
    'I':'R5',
    'H':'R5',
    'G':'R5',
    'F':'R5',
    'E':'R5',
    'D':'R5',
    'C':'R5',
    'A':'R1',
    'B':'R1',
    'Z':'R1',
    'DEAD':'R5',
    '404':'R2',
};

class ApiService {
    constructor() {
        this.authorizationHeader = this.generateAuthorizationHeader();
        // Absolute path (from myajax, localized in functions.php via get_stylesheet_directory_uri())
        // rather than a relative "../" path - a relative path breaks once the current URL is
        // nested more than one segment deep (e.g. /business/produktauswahl/), since "../" only
        // pops a single path segment instead of resolving back to the site root.
        this.proxyUrl = (typeof myajax !== 'undefined' && myajax.proxy_url) || '../wp-content/themes/gruuun-theme/api-proxi.php';
        // Initialize default values
        this.defaultCity = $(SELECTORS.HIDDEN_CITY).val() || '';
        this.defaultTariff = $(SELECTORS.HIDDEN_TARIFF_ID).val() || '';
        this.defaultConsumption = $(SELECTORS.HIDDEN_CONSUMPTION).val() || '';
        this.defaultSupplyChangeCause = $(SELECTORS.SUPPLY_CHANGE_CAUSE).val() || '';
        this.defaultOldSupplierCancellationState = 'oldSupplierNotCanceled';
        this.defaultSupplierOldCancellationDate = this.getDateIncreased();
        this.defaultSupplyBeginDateSpecified = false;
        this.defaultPostalCode = $(SELECTORS.HIDDEN_POSTAL_CODE).val() || '';
        this.defaultstreet = $(SELECTORS.HIDDEN_STREET).val() || '';
        this.defaultHouseNumnber = $(SELECTORS.HIDDEN_HOUSE_NUMBER).val() || '';
        this.defaultSecretKey = $(SELECTORS.HIDDEN_SECRET_KEY_INPUT).val() || '';
        this.defaultReferralContractNumber = $(SELECTORS.HIDDEN_REFERRAL_CONTRACT_NUMBER).val() || '';
        this.formData = {};
        this.debounceTimeout = null;
        this.debounceDelay = 300; // Debounce delay in milliseconds
        this.loading = false;
        this.couponCode = null;
        this.couponArt = null;
        this.couponValue = null;
        this.updating = false;
        this.syncingFlatpickr = false;
        this.wasSendToApi = false;
        this.blacklistCheckPromise = null;
        this.minifiedOverview = $('.multi-step_form_preview .form-box').data('redirect-url');
        this.tariffFormUrl = FORM_URL;
        this.currentFriendsAndFamilyTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-friends');
        this.currentDynamicTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-dynamic');
        this.currentStromsteuerTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-stromsteuer');
        this.currentLightTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-light');
        this.currentFreundeTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-freunde');
        this.currentGemeindestromTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-gemeindestrom');
        this.currentSonnenregionErzgebirgeTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-erzgebirge');
        this.currentDefaultTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-default');
        this.currentBusinessTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-business');
        this.currentSofortSparenOhneBonusTariff = $(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP).hasClass('-sofortsparenohnebonus');

        this.currentBusinessTariffMultistep = $('.main-page-wrap').hasClass('business-tariff-api');

        // "Is this a Business page" for the product-calculator consumption-threshold flow is
        // resolved via AJAX by comparing the current URL against the ACF Options "Business
        // homepage" field, rather than any local/CSS state. Fetched once and cached - every
        // caller reuses this single promise, so only one request fires per page load.
        this.isBusinessPageByUrlPromise = this.checkIsBusinessPageByUrl();

        this.initializeEventListeners();

    }

    initializeEventListeners() {
        const ibanInput = $(SELECTORS.IBAN_INPUT);
        const ownerNameInput = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME);

        $(SELECTORS.SEND_DATA_FORM).on('blur', (SELECTORS.IBAN_INPUT), (event) => {
            const $target = $(event.target);
            if($target.closest('.field-wrap').hasClass('nf-pass')) {
                this.validateIBAN();
            }
        });

        ownerNameInput.on('change', () => {
            this.updateOwnerName();
        });

        swiperMultistep.on('slideChange', () => {
            if (swiperMultistep.realIndex === 3) {
                this.populateFakeInvoiceEmailField();
                this.renderCollectInfo(SELECTORS.COLLECTED_INFO_WRAP_STEP4);
            }
        });

        $(SELECTORS.SEND_DATA_FORM).on('click', '.item.invoiceEmail .open-fields-link a', () => {
            setTimeout(() => {
                this.populateFakeInvoiceEmailField();
            }, 0);
        });

        $(SELECTORS.SEND_DATA_FORM).on('blur change', SELECTORS.FAKE_INVOICE_EMAIL_INPUT, () => {
            this.syncInvoiceEmailFromFakeField();
        });

        // Event listener for when any input (except checkboxes) or select fields lose focus
        $(SELECTORS.SEND_DATA_FORM).on('blur', 'input:not([type="checkbox"]):not([type="radio"]):not(.datepicker-18):not(.datepicker):not(.datepicker-5)', (event) => {
            const $target = $(event.target); // Get the target element
            const name = $target.attr('name'); // Get the name attribute of the target element
            const newValue = $target.val(); // Get the new value of the target element

            // Update values of all fields with the same name
            this.updateFieldValues(name, newValue);
        });

        // Event listener for when any input (except checkboxes) or select fields lose focus
        $(SELECTORS.SEND_DATA_FORM).on('change', '.flatpickr-input', (event) => {
            if (this.syncingFlatpickr) {
                return;
            }

            const $target = $(event.target);
            const name = $target.attr('name');
            const newValue = $target.val();

            if (!name || !newValue) {
                return;
            }

            const fields = document.querySelectorAll(`[name="${name}"]`);

            this.syncingFlatpickr = true;

            $(fields).each((index, field) => {
                const flatpickrInstance = field._flatpickr;

                if (!flatpickrInstance) {
                    $(field).val(newValue).trigger('input').trigger('change');
                    return;
                }

                flatpickrInstance.setDate(newValue, false, 'Y-m-d');

                // Trigger validation/listeners on the original flatpickr input
                $(field).trigger('input').trigger('change');

                // Trigger validation/listeners on the visible flatpickr input
                if (flatpickrInstance.altInput) {
                    $(flatpickrInstance.altInput).trigger('input').trigger('change');
                }

                // Force jQuery validation to re-check the original field
                if ($(field).valid) {
                    $(field).valid();
                }
            });

            this.syncingFlatpickr = false;
        });

        $(SELECTORS.SEND_DATA_FORM).on('change', 'input[name="oldSupplierCancellationState"]', (event) => {
            const $target = $(event.target);
            const value = $target.val();

            if ($target.is(':checked')) {
                if(value === 'oldSupplierNotCanceled') {
                    $('#vertragskundigung-cell').text('von grüüün erledigen lassen');
                } else {
                    $('#vertragskundigung-cell').text('Ich habe bereits gekündigt');
                }
            }
        });

        $(SELECTORS.PAYMENT_TYPE_RADIO).on('change', (event) => {
            const $target = $(event.target);
            const thisValue = $target.val();
            const $ibanChecker = $('#iban-checker');
            const isMobile = $(window).width() <= 1024;

            const paymentTypeValues = {
                'sepaLastschrift': 'SEPA-Lastschrift',
                'rechnung': 'auf Rechnung',
                'rechnungskunden': 'auf Rechnung'
            };

            this.clearInput($(SELECTORS.BANK_ACCOUNT_OWNER_NAME));
            this.clearInput($(SELECTORS.IBAN_INPUT));
            this.clearInput($(SELECTORS.BANK_NAME_INPUT));
            delete this.formData['bankAccountOwnerName']
            delete this.formData['bankAccountIban']
            delete this.formData['bankName'];
            delete this.formData['bankAccountBic'];
            $(SELECTORS.ERROR_NAME_BANK).removeClass('-show');

            $ibanChecker.html(`${paymentTypeValues[thisValue]}`);

            if(isMobile) {
                this.scrollToElement($(SELECTORS.BANK_ACCOUNT_OWNER_NAME).closest('.listcheckbox-container-box'));
            }
        });

        $(SELECTORS.SEND_DATA_FORM).on('change', 'input[name="supplyChangeCause"], input[name="supplyChangeCause-copy"]', (event) => {
            const $target = $(event.target); // Get the target element
            const newValue = $target[0].labels[0].textContent;
            const currentIndex = swiperMultistep.activeIndex;
            const value = $target.val();
            const nameInput = $target.attr('name');

            if ($target.is(':checked')) {
                $(SELECTORS.SEND_DATA_FORM).find('.change-field-73').html('<b>' + newValue + '</b>');
                this.defaultSupplyChangeCause = value;

                if (value === 'move') {
                    $(SELECTORS.SEND_DATA_FORM).find('.collapsed-data .item.newAddress').show();
                    $('#wechsel-cell').text('Umzug an diese Adresse');
                    $(SELECTORS.OLD_SUPPLIER_NAME).empty().trigger('change');
                    this.clearInput($('[name="oldSupplierCustomerNumber"]'));
                    $('[name="supplyBeginDateSpecified"][value="true"]').prop('checked', true).trigger('change');
                    this.clearInput($('[name="supplierOldCancellationDate"]'));

                    if(nameInput === 'supplyChangeCause-copy' && currentIndex === 3) {
                        const $item = $('.collapsed-data .item.newAddress');
                        const $collectedInfoBox = $item.find('.collected-info');
                        const $formFieldsBox = $item.find('.form-fields');
                        const $customerSwitcher = $('.customer-switcher');
                        let headerHeight = $("header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

                        $collectedInfoBox.hide();
                        $formFieldsBox.show();

                        setTimeout(function () {
                            $("html, body").animate({
                                scrollTop: $item.offset().top - headerHeight
                            }, 300);
                        }, 100)
                    }
                } else {
                    $(SELECTORS.SEND_DATA_FORM).find('.collapsed-data .item.newAddress').hide();
                    $('#wechsel-cell').text('an aktueller Adresse');
                    $('[name="supplyBeginDateSpecified"][value="false"]').prop('checked', true).trigger('change');
                    this.clearInput($('[name="supplyBeginDate"]'));
                }
            }
        });

        $(SELECTORS.SEND_DATA_FORM).on('click', '.close-fields-link', (event) => {
            const $item = $(event.target).closest('.item');

            if ($item.hasClass('invoiceEmail')) {
                this.syncInvoiceEmailFromFakeField();
            }

            this.renderCollectInfo(SELECTORS.COLLECTED_INFO_WRAP_STEP4);
        });

        // Event listener for radio buttons to sync values
        $(SELECTORS.SEND_DATA_FORM).on('change', 'input[type="radio"]', (event) => {
            const $target = $(event.target);
            const name = $target.attr('name');
            const value = $target.val();

            // Check if the name ends with '-copy'
            if (name.endsWith('-copy')) {
                const originalName = name.replace('-copy', '');
                this.updateRadioButtons(originalName, value);
            } else {
                const copyName = `${name}-copy`;
                this.updateRadioButtons(copyName, value);
            }
        });

        $(SELECTORS.SEND_DATA_FORM).on('change', 'input[type="checkbox"]', (event) => {
            const $target = $(event.target);
            const name = $target.attr('name');
            const isChecked = $target.is(':checked') ? 'true' : 'false';

            // Перевіряємо, чи ім'я закінчується на '-copy'
            if (name.endsWith('-copy')) {
                const originalName = name.replace('-copy', '');
                this.updateCheckboxes(originalName, isChecked);
            } else {
                const copyName = `${name}-copy`;
                this.updateCheckboxes(copyName, isChecked);
            }
        });

        // Event listener for when any input (except checkboxes) or select fields lose focus
        $(SELECTORS.SEND_DATA_FORM).on('select2:select', 'select', (event) => {
            const $target = $(event.target); // Get the target element
            const name = $target.closest('.nf-field-element').find('select').attr('name'); // Get the name attribute of the target element
            let newValue = $target.val(); // Get the new value of the target element
            let newLabel = $target.select2('data')[0].text; // Get the new value of the target element
            const $select = $('select[name="' + name + '"]');

            if ($.isArray(newValue)) {
                newValue = newValue[0];
            }

            if ($target.hasClass('-supplier')) {
                const loadingOption = new Option(newLabel, newValue, true, true);
                $select.empty().trigger('change');
                $select.append(loadingOption);
                $select.val(newValue).trigger('change');
            } else {
                $select.val(newValue).trigger('change');
            }
        });

        $(SELECTORS.STREET_POPUP).on('click','.close-popup-box a, .popup-overlay', (e) => {
            e.preventDefault();
            $(SELECTORS.STREET_POPUP).removeClass('showStreet');
            $('body').removeClass('overflow-hidden');

            setTimeout(() => {
                $(SELECTORS.STREET_INPUT_FAKE).val('').trigger('change');
                $(SELECTORS.HOUSE_NUMBER_INPUT_FAKE).val('').trigger('change');
                $(SELECTORS.STREET_POPUP).find('.nf-error').removeClass('nf-error');
                $(SELECTORS.STREET_POPUP).find('.label-up').removeClass('label-up');
            }, 300)
        })

        $(SELECTORS.STREET_POPUP_FORM).submit((e) => {
            e.preventDefault();
        });

        $(SELECTORS.STREET_POPUP_FORM).on('click','.submit-button', (e) => {
            e.preventDefault();

            let allValid = this.validatePopupForm();

            if (allValid) {
                $('body').removeClass('overflow-hidden');

                $(SELECTORS.STREET_POPUP).removeClass('showStreet');

                $(SELECTORS.FIND_TARIFF_FORM).find('[type="submit"]').click();
            }
        })

        $(SELECTORS.RESULT_TARIFF).on('click', '#streetInFirstStep', (e) => {
            e.preventDefault();

            if (!$('.multi-step_form_preview.tariff-api form .field-wrap.nf-error').length > 0) {
                $(SELECTORS.STREET_POPUP).addClass('showStreet');
                $('body').addClass('overflow-hidden');
            }

        })
        $('.multi-step_form_preview').on('blur', SELECTORS.POSTAL_CODE_AND_ORT_SELECT_SELECT2_TEXTAREA, (event) => {
            if ($(SELECTORS.STREET_POPUP).hasClass('showStreet')) {
                $('body').removeClass('overflow-hidden');
                $(SELECTORS.STREET_POPUP).removeClass('showStreet');
                this.destroySelect2(SELECTORS.STREET_INPUT_FAKE);
                this.clearErrorMsg();
            }
        });

        $(SELECTORS.RESULT_TARIFF).on('click', '#cityInFirstStep', (e) => {
            e.preventDefault();

            if (!$('.multi-step_form_preview.tariff-api form .field-wrap.nf-error').length > 0) {
                this.scrollToElement($(SELECTORS.MULTISTEP_TARIFF_FORM_WRAP));
                this.clearErrorMsg();
            }

        });


    }

    getDateIncreased() {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 20);
        return currentDate.toISOString();
    }

    validatePopupForm() {
        const inputs = $(SELECTORS.STREET_POPUP_FORM).find(':input');
        const selects = $(SELECTORS.STREET_POPUP_FORM).find('select');
        let allValid = true;

        inputs.each(function () {
            let $containerOfInput = $(this).closest('.field-wrap')

            $(SELECTORS.STREET_POPUP_FORM).validate().element(this);
            if (!this.checkValidity() || $containerOfInput.hasClass('nf-error')) {
                allValid = false;
            }
        });

        selects.each(function () {
            let $containerOfInput = $(this).closest('.field-wrap')

            $(SELECTORS.STREET_POPUP_FORM).validate().element(this);
            if (!this.checkValidity() || $containerOfInput.hasClass('nf-error')) {
                allValid = false;
            }
        });

        return allValid;
    }

    scrollToElement(elem) {
        const $customerSwitcher = $('.customer-switcher');
        const headerHeight = $("header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

        $("html, body").animate({
            scrollTop: elem.offset().top - headerHeight
        }, 300);
    }

    clearForm(form) {
        form.trigger('reset');
        const inputs = form.find(':input');
        const selects = form.find('select');

        inputs.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $wrapOfInput = $(this).closest('.field-wrap');
            let $errorMessage = $containerOfInput.find('.nf-error-msg');

            $containerOfInput.removeClass('label-up');
            $wrapOfInput.removeClass('nf-error nf-pass');
            $errorMessage.html();
        });

        selects.each(function () {
            let $wrapOfSelect = $(this).closest('.field-wrap')
            $(this).removeClass('-filled');
            $wrapOfSelect.removeClass('nf-error nf-pass');
        });

    };

    clearInput(elem) {
        let inputWrap = elem.closest('.field-wrap');
        let errorWrap = inputWrap.find('.nf-error-msg, .iban-error-msg');
        let inputCont = elem.closest('.nf-field-container');
        let $attr = elem.attr('required');

        inputWrap.removeClass('nf-error nf-pass iban-api-error');
        inputCont.removeClass('label-up');
        errorWrap.html('');
        elem.val('').trigger('change');

        inputCont.removeClass('potentially-required-label');
        inputCont.removeClass('label-focus');
        if (elem.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                inputCont.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                inputCont.removeClass('required-label');
            }
        }
    }
    clearInputs(parent) {
        parent.each(function () {
            let elem = $(this);
            // console.log(elem);
            let inputWrap = elem.closest('.field-wrap');
            let errorWrap = inputWrap.find('.nf-error-msg, .iban-error-msg');
            let inputCont = elem.closest('.nf-field-container');
            let $attr = elem.attr('required');

            inputWrap.removeClass('nf-error nf-pass iban-api-error');
            inputCont.removeClass('label-up');
            errorWrap.html('');
            elem.val('').trigger('change');

            inputCont.removeClass('potentially-required-label');
            inputCont.removeClass('label-focus');
            if (elem.val().trim() === '') {
                if (typeof $attr !== 'undefined' && $attr !== false) {
                    inputCont.addClass('required-label');
                }
            } else {
                if (typeof $attr !== 'undefined' && $attr !== false) {
                    inputCont.removeClass('required-label');
                }
            }
        })
    }

    increaseDate(dateString) {
        if(!dateString) return '';
        const date = new Date(dateString);

        date.setDate(date.getDate() + 1);

        return date.toISOString();

    }

    translateToGermanLetters(text, maxLength = 999) {
        const map = {
            'ß': 'ss', 'Ä': 'Ae', 'Ö': 'Oe', 'Ü': 'Ue', 'ä': 'ae', 'ö': 'oe', 'ü': 'ue',
            'Ą': 'A', 'ą': 'a', 'Ł': 'L', 'ł': 'l', 'Ľ': 'L', 'ľ': 'l',
            'Ś': 'S', 'ś': 's', 'Š': 'S', 'š': 's', 'Ş': 'S', 'ş': 's',
            'Ť': 'T', 'ť': 't', 'Ź': 'Z', 'ź': 'z', 'Ž': 'Z', 'ž': 'z',
            'Ż': 'Z', 'ż': 'z', 'Ŕ': 'R', 'ŕ': 'r', 'Á': 'A', 'á': 'a',
            'Â': 'A', 'â': 'a', 'Ă': 'A', 'ă': 'a', 'Ĺ': 'L', 'ĺ': 'l',
            'Ć': 'C', 'ć': 'c', 'Ç': 'C', 'ç': 'c', 'Č': 'C', 'č': 'c',
            'É': 'E', 'é': 'e', 'Ę': 'E', 'ę': 'e', 'Ë': 'E', 'ë': 'e',
            'Ě': 'E', 'ě': 'e', 'Í': 'I', 'í': 'i', 'Î': 'I', 'î': 'i',
            'Ď': 'D', 'ď': 'd', 'Ɖ': 'D', 'đ': 'd', 'Ń': 'N', 'ń': 'n',
            'Ň': 'N', 'ň': 'n', 'Ó': 'O', 'ó': 'o', 'Ô': 'O', 'ô': 'o',
            'Ő': 'O', 'ő': 'o', 'Ř': 'R', 'ř': 'r', 'Ů': 'U', 'ů': 'u',
            'Ú': 'U', 'ú': 'u', 'Ű': 'U', 'ű': 'u', 'Ý': 'Y', 'ý': 'y',
            'Ţ': 'T', 'ţ': 't', 'Ã': 'A', 'Å': 'A', 'Æ': 'AE', 'È': 'E',
            'Ê': 'E', 'Ì': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O',
            'Õ': 'O', 'Ø': 'O', 'Ù': 'U', 'Û': 'U', 'Þ': 'Th', 'À': 'A',
            'à': 'a', 'ã': 'a', 'å': 'a', 'æ': 'ae', 'è': 'e', 'ê': 'e',
            'ì': 'i', 'ï': 'i', 'ð': 'd', 'ñ': 'n', 'ò': 'o', 'õ': 'o',
            'ø': 'o', 'ù': 'u', 'û': 'u', 'þ': 'th', 'ÿ': 'y', 'Œ': 'OE',
            'œ': 'oe', 'Ÿ': 'Y', 'ƒ': 'f'
        };

        if (!text) {
            return '';
        }

        // Replace characters using the map
        let translatedText = text.split('').map(char => map[char] || char).join('');

        // Trim the text to the maxLength if needed
        if (maxLength && translatedText.length > maxLength) {
            translatedText = translatedText.substring(0, maxLength);
        }

        return translatedText;
    }

    convertDate(dateString, isISO = false) {
        if (!dateString) {
            return '';
        }

        // parse input (assumes "YYYY-MM-DD" or any ISO‐compatible string)
        const m = moment(dateString, "YYYY-MM-DD");

        if (isISO) {
            // return full ISO 8601 string with time and UTC offset
            return m.format("YYYY-MM-DD[T]00:00:00.000[Z]");
        } else {
            // return just day.month.year for display
            return m.format("DD.MM.YYYY");
        }
    }

    updateFieldValues(name, newValue) {
        if (this.updating) return; // Prevent updating if already in progress

        this.updating = true; // Set the flag to indicate that updating is in progress

        // Update all elements with the given name and trigger 'change' for select2 elements
        $(`[name="${name}"]`).each((index, element) => {
            $(element).val(newValue).trigger('change');
        });

        this.updating = false; // Reset the flag after updating is complete
    }

    updateRadioButtons(name, value) {
        if (this.updating) return; // Prevent updating if already in progress

        this.updating = true; // Set the flag to indicate that updating is in progress

        // Update all radio buttons with the given name
        $(`[name="${name}"]`).each((index, element) => {
            if ($(element).val() === value) {
                $(element).prop('checked', true).trigger('change');
            } else {
                $(element).prop('checked', false).trigger('change');
            }
        });

        this.updating = false; // Reset the flag after updating is complete
    }

    updateCheckboxes(name, value) {
        if (this.updating) return; // Prevent updating if already in progress

        this.updating = true; // Set the flag to indicate that updating is in progress

        // Update all radio buttons with the given name
        $(`[name="${name}"]`).each((index, element) => {
            if (value === 'true') {
                $(element).prop('checked', true).trigger('change');
            } else {
                $(element).prop('checked', false).trigger('change');
            }
        });

        this.updating = false;  // Reset the flag after updating is complete
    }

    getMainEmailValue() {
        return $.trim($('input[name="email"]').first().val() || '');
    }

    getInvoiceEmailValue() {
        return $.trim($(SELECTORS.INVOICE_EMAIL_INPUT).first().val() || '');
    }

    isDifferentInvoiceEmailEnabled() {
        return $(SELECTORS.DIFFERENT_INVOICE_EMAIL_CHECKBOX).first().is(':checked');
    }

    setDifferentInvoiceEmailState(enabled) {
        $(SELECTORS.DIFFERENT_INVOICE_EMAIL_CHECKBOX)
            .prop('checked', enabled)
            .trigger('change');
    }

    setInvoiceEmailValue(value) {
        $(SELECTORS.INVOICE_EMAIL_INPUT)
            .val(value)
            .trigger('input')
            .trigger('change');
    }

    populateFakeInvoiceEmailField() {
        const $fakeInput = $(SELECTORS.FAKE_INVOICE_EMAIL_INPUT);

        if (!$fakeInput.length) {
            return;
        }

        const mainEmail = this.getMainEmailValue();
        const invoiceEmail = this.getInvoiceEmailValue();
        const hasDifferentInvoiceEmail = this.isDifferentInvoiceEmailEnabled();

        const value = hasDifferentInvoiceEmail && invoiceEmail
            ? invoiceEmail
            : mainEmail;

        $fakeInput.val(value).trigger('input');

        if (value) {
            $fakeInput.closest('.nf-field-container').addClass('label-up');
            $fakeInput.closest('.field-wrap').removeClass('nf-error');
            $fakeInput.closest('.nf-field-container').find('.nf-error-msg').html('');
            $fakeInput.attr('aria-invalid', 'false');
        }
    }

    syncInvoiceEmailFromFakeField({ skipEmpty = false } = {}) {
        const $fakeInput = $(SELECTORS.FAKE_INVOICE_EMAIL_INPUT);

        if (!$fakeInput.length) {
            return;
        }

        const fakeEmail = $.trim($fakeInput.val() || '');
        const mainEmail = this.getMainEmailValue();

        if (!fakeEmail && skipEmpty) {
            return;
        }

        if (!fakeEmail) {
            return;
        }

        if (fakeEmail.toLowerCase() === mainEmail.toLowerCase()) {
            this.setDifferentInvoiceEmailState(false);
            this.setInvoiceEmailValue('');
        } else {
            this.setDifferentInvoiceEmailState(true);
            this.setInvoiceEmailValue(fakeEmail);
        }
    }

    // Generate Authorization Header
    generateAuthorizationHeader() {
        const encodedCredentials = btoa(`${this.username}:${this.password}`);
        return `Basic ${encodedCredentials}`;
    }

    // Send Data and Redirect
    sendDataAndRedirect(postalCode, city, consumption, redirectUrl = '', markAsPrivateCustomer = false) {
        const fallbackUrl = this.currentStromsteuerTariff ? TEST_URL_STROMSTEUER : TEST_URL;
        const targetUrl = normalizeUrl(redirectUrl) || normalizeUrl(fallbackUrl);

        const url = new URL(targetUrl);

        url.searchParams.append('postalcode', postalCode);
        url.searchParams.append('city', city);
        url.searchParams.append('consumption', consumption);

        // Temporary frontend-only handoff marker to the real find-tariff form - only set when
        // the user explicitly chose "Ich bin Privatkunde" in the threshold popup (see the
        // nfFormSubmitResponse handler below). Never persisted, never sent to any API payload.
        if (markAsPrivateCustomer) {
            url.searchParams.set('isPrivateCustomer', '1');
        }

        window.location.href = url.toString();
    }

    // Frontend-only isPrivateCustomer handoff marker, snapshotted at script load (see
    // INCOMING_PRIVATE_CUSTOMER_MARKER above - a live read here would be too late). Used only by
    // the real find-tariff form to skip the repeated popup1 (private/business choice) after the
    // fake widget already asked - never skips popup2, and never affects validation, the reject
    // branch, or the tariff API call.
    hasIncomingPrivateCustomerMarker() {
        return INCOMING_PRIVATE_CUSTOMER_MARKER;
    }

    setTariffFormUrl(url) {
        const normalizedUrl = normalizeUrl(url);

        if (normalizedUrl) {
            this.tariffFormUrl = normalizedUrl;
        }
    }

    // Numeric threshold decision for the Privatkunden product calculator. Preserves existing
    // behaviour for missing/invalid/zero/negative values (treated as 'proceed', same as before
    // this feature existed) - only a positive number above the popup-1 threshold changes anything.
    evaluateConsumptionThreshold(consumption) {
        const value = parseFloat(consumption);

        if (!Number.isFinite(value) || value <= 0) {
            return 'proceed';
        }

        if (value <= CONSUMPTION_THRESHOLD_POPUP_1) {
            return 'proceed';
        }

        if (value <= CONSUMPTION_THRESHOLD_POPUP_2) {
            return 'popup1';
        }

        if (value <= CONSUMPTION_THRESHOLD_MAX) {
            return 'popup2';
        }

        return 'reject';
    }

    // Existing field-error UX (.nf-error / .nf-error-msg), reused instead of a new error style.
    showConsumptionLimitError($consumptionInput) {
        const $wrap = $consumptionInput.closest('.field-wrap');
        const $errorMsg = $consumptionInput.closest('.nf-field-container').find('.nf-error-msg');

        $wrap.addClass('nf-error').removeClass('nf-pass');

        if ($errorMsg.length) {
            $errorMsg.text('Dieser Wert ist zu hoch. Bitte gib einen Jahresverbrauch bis 100.000 kWh ein.');
        }

        $consumptionInput.trigger('focus');
    }

    // Reads the combined postalcode_ort selection from whichever widget (.find-tariff or
    // .fake-find-tariff) is currently submitting - same value shape both widgets already use.
    readWidgetLocation(widgetSelector) {
        let postalCode = '';
        let city = '';

        try {
            let raw = $(`${widgetSelector} select[name="postalcode_ort"]`).val();

            if ($.isArray(raw)) {
                raw = raw[0];
            }

            if (raw) {
                const parsed = JSON.parse(raw);
                postalCode = parsed.code || '';
                city = parsed.city || '';
            }
        } catch (e) {
            console.error('Failed to read postal code / city for the business handoff.');
        }

        return {postalCode, city};
    }

    getBusinessProduktauswahlUrl() {
        return window.location.origin + BUSINESS_PRODUKTAUSWAHL_URL;
    }

    // Resolves to true/false (never rejects) - fetches the ACF Options "Business homepage" URL
    // and checks whether the current page's path starts with it.
    checkIsBusinessPageByUrl() {
        return $.ajax({
            url: myajax.url,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'get_business_homepage_url',
                nonce: myajax.nonces.get_business_homepage_url
            }
        }).then((response) => {
            const businessHomepageUrl = (response && response.success && response.data && response.data.businessHomepageUrl) || '';

            if (!businessHomepageUrl) {
                return false;
            }

            try {
                const businessPath = new URL(businessHomepageUrl, window.location.origin).pathname;
                return businessPath !== '/' && window.location.pathname.indexOf(businessPath) === 0;
            } catch (e) {
                return false;
            }
        }).catch(() => false);
    }

    // Generic accessible popup used by the consumption-threshold flow (popup 1 / popup 2).
    // Not built on the existing .tooltip-popup pattern because that one has no focus
    // management/trap/restore at all - required here per the task's accessibility requirements.
    showConsumptionThresholdPopup({title, body, primaryLabel, onPrimary, secondaryLabel, onSecondary}) {
        if (this.consumptionPopupOpen) {
            return;
        }

        const titleId = 'consumption-threshold-popup-title';
        const descId = 'consumption-threshold-popup-desc';

        const $popup = $(
            '<div class="consumption-popup" role="dialog" aria-modal="true" aria-labelledby="' + titleId + '" aria-describedby="' + descId + '">' +
                '<div class="consumption-popup__overlay"></div>' +
                '<div class="consumption-popup__box">' +
                    '<h3 class="consumption-popup__title" id="' + titleId + '"></h3>' +
                    '<p class="consumption-popup__text" id="' + descId + '"></p>' +
                    '<div class="consumption-popup__actions">' +
                        '<button type="button" class="btn-cta consumption-popup__primary"></button>' +
                        '<button type="button" class="consumption-popup__secondary"></button>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );

        $popup.find('.consumption-popup__title').text(title);
        $popup.find('.consumption-popup__text').text(body);
        $popup.find('.consumption-popup__primary').text(primaryLabel);
        $popup.find('.consumption-popup__secondary').text(secondaryLabel);

        $('body').append($popup).addClass('overflow-hidden');

        this.consumptionPopupOpen = true;
        this.consumptionPopupReturnFocus = document.activeElement;

        $popup.find('.consumption-popup__primary').trigger('focus');

        const close = (callback) => {
            if (!this.consumptionPopupOpen) {
                return;
            }

            this.consumptionPopupOpen = false;
            $(document).off('keydown.consumptionPopup');
            $popup.remove();
            $('body').removeClass('overflow-hidden');

            const $returnFocus = $(this.consumptionPopupReturnFocus);
            if ($returnFocus.length && document.body.contains(this.consumptionPopupReturnFocus)) {
                $returnFocus.trigger('focus');
            }

            if (typeof callback === 'function') {
                callback();
            }
        };

        $popup.find('.consumption-popup__primary').on('click', () => close(onPrimary));
        $popup.find('.consumption-popup__secondary').on('click', () => close(onSecondary));
        // Overlay click / Escape dismiss the popup without triggering either action, per the
        // project's existing modal convention (close-button/overlay just close) plus the task's
        // explicit "dismissal must not accidentally calculate or redirect" requirement.
        $popup.find('.consumption-popup__overlay').on('click', () => close(null));

        $(document).on('keydown.consumptionPopup', (e) => {
            if (e.key === 'Escape') {
                close(null);
                return;
            }

            if (e.key === 'Tab') {
                const focusable = $popup.find('button').toArray();

                if (focusable.length === 0) {
                    return;
                }

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });
    }

    showConsumptionPopup1(onPrivate, onBusiness) {
        this.showConsumptionThresholdPopup({
            title: 'Bist Du Privatkunde?',
            body: 'Dein Verbrauch liegt über 10.000 kWh / Jahr. Bist Du Privat- oder Geschäftskunde?',
            primaryLabel: 'Ich bin Privatkunde',
            onPrimary: onPrivate,
            secondaryLabel: 'Ich bin Geschäftskunde',
            onSecondary: onBusiness
        });
    }

    showConsumptionPopup2(onBusiness) {
        this.showConsumptionThresholdPopup({
            title: 'Bist Du Geschäftskunde?',
            body: 'Der maximale Verbrauch für Privathaushalte liegt bei 20.000 kWh / Jahr. Bist Du Geschäftskunde?',
            primaryLabel: 'Als Geschäftskunde weiter',
            onPrimary: onBusiness,
            secondaryLabel: 'zurück',
            onSecondary: () => {
                window.location.href = window.location.origin + '/';
            }
        });
    }

    getTariffFormUrl() {
        return this.tariffFormUrl || FORM_URL;
    }

    showLoader() {
        $(SELECTORS.LOADER).show();
        $(SELECTORS.RESULT_TARIFF).show();
        $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER).hide();
    }

    hideLoader() {
        $(SELECTORS.LOADER).hide();
        $(SELECTORS.RESULT_TARIFF).show();
        $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER).show();
    }

    // Get Cities
    getCities(postalCode) {
        return $.ajax({
            url: `${this.proxyUrl}?type=getCities`,
            method: 'GET',
            data: {postalCode},
            headers: {'Authorization': this.authorizationHeader},
            success: (response) => {
                // console.log(response);
            },
            error: (xhr, status, error) => {
                // console.error('Error:', error);
                console.log(xhr.responseText);
            }
        });
    }

    // Get Price Information
    getPriceInformation(city, postalCode, consumption, street = '', houseNumber = '') {
        const requestBody = {
            address: {city, postalCode},
            consumption,
            requestDate: new Date().toISOString(),
            section: "Electricity"
        };
        if (street) {
            requestBody.address.street = street;
            requestBody.address.housenumber = houseNumber;
        }
        return $.ajax({
            url: `${this.proxyUrl}?type=getPriceInformation`, // change url !!!!
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestBody),
            headers: {'Authorization': this.authorizationHeader}
        });
    }

    // Render Price Information
    renderPriceInformation(data, city, postalCode, street = '', houseNumber = '', consumption, secretKey = '', referralContractNumber = '') {
        const $this = this;
        function formatNumber(input, useFixed = false) {
            let number = parseFloat(input);

            if (isNaN(number)) {
                return input;
            }

            let formattedNumber;

            if (useFixed) {
                formattedNumber = number.toFixed(2);
            } else {
                formattedNumber = number.toFixed(0);
            }

            formattedNumber = formattedNumber.replace('.', ',');

            formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            return formattedNumber;
        }

        function initComparisonLayout() {
            const $layout = $('.tariff-comparison-layout');

            if (!$layout.length) {
                return;
            }

            const mobileBreakpoint = 1024;

            function setActiveTariff(tariffId) {
                $layout.attr('data-active-tariff-id', tariffId);

                $layout.find('.tariff-comparison-tab').removeClass('is-active');
                $layout.find(`.tariff-comparison-tab[data-tariff-id="${tariffId}"]`).addClass('is-active');

                $layout.find('.comparison-tariff-card').removeClass('is-active');
                $layout.find(`.comparison-tariff-card[data-tariff-id="${tariffId}"]`).addClass('is-active');

                $layout.find('.comparison-table__value').removeClass('is-active');
                $layout.find(`.comparison-table__value[data-tariff-id="${tariffId}"]`).addClass('is-active');

                $layout.find('.mobile-choose-tariff').attr('data-tariff-id', tariffId);
            }

            function toggleMobileBookingButton() {
                if ($(window).width() > mobileBreakpoint) {
                    $layout.removeClass('is-mobile-button-visible');
                    return;
                }

                const $cards = $layout.find('.tariff-comparison-cards');

                if (!$cards.length) {
                    $layout.removeClass('is-mobile-button-visible');
                    return;
                }

                const cardsBottom = $cards[0].getBoundingClientRect().bottom;
                const layoutBottom = $layout[0].getBoundingClientRect().bottom;
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                const isCardsAboveViewport = cardsBottom < 88;
                const isLayoutStillVisible = layoutBottom > windowHeight * 0.35;

                if (isCardsAboveViewport && isLayoutStillVisible) {
                    $layout.addClass('is-mobile-button-visible');
                } else {
                    $layout.removeClass('is-mobile-button-visible');
                }
            }

            $layout.off('click.comparisonTabs').on('click.comparisonTabs', '.tariff-comparison-tab', function () {
                const tariffId = $(this).data('tariff-id');

                setActiveTariff(tariffId);
            });

            $layout.off('click.comparisonMobileButton').on('click.comparisonMobileButton', '.mobile-choose-tariff', function () {
                const tariffId = $(this).attr('data-tariff-id');

                $(`#choose-tariff-btn-${tariffId}`).trigger('click');
            });

            $(window)
                .off('scroll.comparisonMobileBooking resize.comparisonMobileBooking')
                .on('scroll.comparisonMobileBooking resize.comparisonMobileBooking', function () {
                    window.requestAnimationFrame(toggleMobileBookingButton);
                });

            toggleMobileBookingButton();
        }

        function renderComparisonTariffCard(tariffData, index) {
            const totalCostPerMonthText = formatNumber(tariffData.totalCostPerMonth, true);
            const isActive = index === 0;

            const badgeHtml = tariffData.enableBadge && tariffData.bonusPercentage
                ? `<div class="badge">${tariffData.bonusPercentage}% geschenkt!</div>`
                : '';

            return `
        <div class="comparison-tariff-card ${isActive ? 'is-active' : ''}" data-tariff-id="${tariffData.id}">
            <div class="comparison-tariff-card__top">
                ${badgeHtml}

                <h4>
                    <span class="tariff-name" lang="de">
                        ${tariffData.nameExtern}
                    </span>
                    <a href="#tooltip-tariff-info-${tariffData.id}" class="tooltip-icon"></a>
                </h4>

                ${tariffData.shortDescriptionComparison ? `
                    <div class="comparison-tariff-card__description">
                        ${tariffData.shortDescriptionComparison}
                    </div>
                ` : ''}
            </div>

            <div class="comparison-tariff-card__bottom">
                <div class="comparison-tariff-card__price">
                    <span>${totalCostPerMonthText} €</span> / Monat
                    <a href="#tooltip-tariff-price-${tariffData.id}" class="tooltip-icon"></a>
                </div>

                <form id="tariff-form-${tariffData.id}" method="post">
                    <input type="hidden" name="encodedData">
                    <button id="choose-tariff-btn-${tariffData.id}" type="button" class="btn" disabled>
                        Tarif buchen
                    </button>
                </form>
            </div>
        </div>
    `;
        }

        function renderComparisonTabs(tariffs) {
            return `
        <div class="tariff-comparison-tabs-box">
            <div class="tariff-comparison-tabs">
                ${tariffs.map((tariffData, index) => `
                    <button 
                        type="button" 
                        class="tariff-comparison-tab ${index === 0 ? 'is-active' : ''}" 
                        data-tariff-id="${tariffData.id}"
                    >
                        ${tariffData.nameExtern}
                    </button>
                `).join('')}
            </div>
        </div>
    `;
        }

        function renderComparisonTable(tariffs) {
            function renderComparisonValue(value) {
                if (value === true || value === '1' || value === 1 || value === 'true') {
                    return '<span class="comparison-check-icon"></span>';
                }

                if (value === false || value === '0' || value === 0 || value === 'false') {
                    return '';
                }

                return value || '';
            }

            function renderGuaranteeValue(value) {
                const formattedValue = renderComparisonValue(value);

                if (!formattedValue) {
                    return '';
                }

                return `<span class="comparison-guarantee-value">${formattedValue}</span>`;
            }

            function renderRow(label, values, rowClass = '') {
                return `
            <tr class="${rowClass}">
                <td class="comparison-table__label">${label}</td>

                ${values.map(item => `
                    <td 
                        class="comparison-table__value ${item.isActive ? 'is-active' : ''}" 
                        data-tariff-id="${item.id}"
                    >
                        ${item.value}
                    </td>
                `).join('')}
            </tr>
        `;
            }

            function mapValues(callback) {
                return tariffs.map((tariffData, index) => {
                    return {
                        id: tariffData.id,
                        isActive: index === 0,
                        value: callback(tariffData)
                    };
                });
            }

            return `
        <div class="comparison-table-wrapper">
            <div class="comparison-table-section">
                <h4>
                    Arbeitspreis
                    <a href="#tooltip-comparison-arbeitspreis" class="tooltip-icon"></a>
                </h4>

                <table class="comparison-table">
                    <tbody>
                        ${renderRow(
                'Basispreis netto',
                mapValues(tariffData => `${formatNumber(tariffData.energiepreis, true)} ct / kWh`)
            )}

                        ${renderRow(
                'grüüün Rabatt',
                mapValues(tariffData => `${formatNumber(tariffData.gruuunBonus, true)} ct / kWh`)
            )}

                        ${renderRow(
                'Dein Energiepreis netto',
                mapValues(tariffData => `${formatNumber(tariffData.energiepreisPlusBonus, true)} ct / kWh`)
            )}

                        ${renderRow(
                'Netzentgelte, Steuern und Gebühren<br><small>(darauf haben wir keinen Einfluss)</small>',
                mapValues(tariffData => {
                    const value = (tariffData.energyPriceGross * 100) - tariffData.energiepreisPlusBonus;
                    return `${formatNumber(value, true)} ct / kWh`;
                })
            )}

                        ${renderRow(
                'Arbeitspreis brutto',
                mapValues(tariffData => `${formatNumber(tariffData.energyPriceGross * 100, true)} ct / kWh`),
                '-highlight'
            )}
                    </tbody>
                </table>
            </div>

            <div class="comparison-table-section">
                <h4>
                    Grundgebühr
                    <a href="#tooltip-comparison-grundgebuehr" class="tooltip-icon"></a>
                </h4>

                <table class="comparison-table">
                    <tbody>
                        ${renderRow(
                'grüüün Grundpreis',
                mapValues(tariffData => `${formatNumber(tariffData.unsereGebuhr, true)} € / Monat`)
            )}

                        ${renderRow(
                'Messstellen- / Netzbetreiber<br><small>(darauf haben wir keinen Einfluss)</small>',
                mapValues(tariffData => {
                    const value = tariffData.baseFeeGross - tariffData.unsereGebuhr;
                    return `${formatNumber(value, true)} € / Monat`;
                })
            )}

                        ${renderRow(
                'Grundpreis brutto',
                mapValues(tariffData => `${formatNumber(tariffData.baseFeeGross, true)} € / Monat`),
                '-highlight'
            )}
                    </tbody>
                </table>
            </div>

            <div class="comparison-table-section comparison-table-section--general">
                <h4>
                    Allgemeine Informationen
                </h4>

                <table class="comparison-table">
                    <tbody>
                        ${renderRow(
                'Garantie auf Energie- und grüüün Grundpreis',
                mapValues(tariffData => renderGuaranteeValue(tariffData.garantieAufEnergie))
            )}

                        ${renderRow(
                '100% Grünstrom aus Deutschland',
                mapValues(tariffData => renderComparisonValue(tariffData.grunstromAusDeutschland))
            )}

                        ${renderRow(
                'Mindestvertragslaufzeit',
                mapValues(tariffData => renderComparisonValue(tariffData.mindestVertragslaufzeit))
            )}

                        ${renderRow(
                'Kündigungsfrist',
                mapValues(tariffData => renderComparisonValue(tariffData.kundigungsfrist))
            )}
                    </tbody>
                </table>
            </div>
        </div>
    `;
        }

        function renderComparisonLayout(tariffs) {
            const cardsHtml = tariffs.map((tariffData, index) => {
                return renderComparisonTariffCard(tariffData, index);
            }).join('');

            const $generalInfo = $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER)
                .children('.tariff-general-info')
                .first();

            const generalInfoCopyHtml = $generalInfo.length
                ? $('<div>')
                    .append(
                        $generalInfo
                            .clone()
                            .removeAttr('style')
                            .removeClass('tariff-general-info--comparison-copy')
                            .addClass('tariff-general-info--comparison-copy')
                            .show()
                    )
                    .html()
                : '';

            const tooltipsHtml = tariffs.map(tariffData => {
                return `
            ${tariffData.tooltipPriceHtml}
            ${tariffData.tooltipBaseFeeHtml}
            ${tariffData.tooltipElectricityPriceHtml}
            ${tariffData.tooltipTariffInfoHtml}
        `;
            }).join('');

            const firstTariff = tariffs[0];

            return `
        <div class="tariff-comparison-layout" data-active-tariff-id="${firstTariff.id}">
            <div class="tariff-comparison-hero-row">
                ${generalInfoCopyHtml}

                <div class="tariff-comparison-sticky">
                    <div class="tariff-comparison-cards">
                        ${cardsHtml}
                    </div>
                </div>
            </div>

            ${renderComparisonTabs(tariffs)}

            ${renderComparisonTable(tariffs)}

            ${tooltipsHtml}

            <div class="tariff-comparison-mobile-booking">
                <button 
                    type="button" 
                    class="btn" 
                    data-tariff-id="${firstTariff.id}"
                >
                    Tarif buchen
                </button>
            </div>
        </div>
    `;
        }

        function formatBusinessPrice(value, tariffId, fieldName) {
            if (value === undefined || value === null || value === '' || isNaN(parseFloat(value))) {
                console.error(`Business tariff price field "${fieldName}" is missing for tariff id ${tariffId}`);
                return '–';
            }

            return `${formatNumber(value, true)} €`;
        }

        function renderStep4TableTotalPrice(tariff_id, consumption, runtimeInMonth, baseFeeGross, totalExpensesCostPerYear, upto1000kwh, totalExpensesCostPerKwHInEuro, totalChargesPerKwHInEuro, totalCostPerMonth, energyPriceNet, energyPriceGross, energiepreis, unsereGebuhr, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, bonusPercentage) {
            let tablesHtml;
            let runtimeInMonthText = $this.currentDynamicTariff ? `1 Monat`:`${runtimeInMonth} Monate`;
            let years = '10';

            if($this.currentBusinessTariff) {
                years = '3';
            } else if($this.currentFreundeTariff) {
                years = '5';
            } else if($this.currentGemeindestromTariff) {
                years = '6';
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                years = '20';
            }

            let unsereGebuhrTextSmall = $this.currentDynamicTariff || $this.currentLightTariff || $this.currentFreundeTariff || $this.currentGemeindestromTariff || $this.currentSonnenregionErzgebirgeTariff || $this.currentBusinessTariff || $this.currentSofortSparenOhneBonusTariff ? '' : `(${years} Jahre Garantie)`;


            if($this.currentDynamicTariff) {
                tablesHtml = `<table>
                          <tr>
                              <td>Energiepreis netto <br> <small>(stundenaktuell EPEX Börsenpreis)</small></td>
                              <td><b>Dynamischer Preis</b></td>
                          </tr>
                          <tr>
                              <td>Weitere Preisbestandteile <br> <small>(Umlagen, Netzentgelte, Steuern, Gebühren)</small></td>
                              <td><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)}  ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</td>
                              <td><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</td>
                          </tr>
                      </table>
                      
                      <div class="total">
                          <table>
                              <tr>
                                  <td>
                                      <h4>Rechnerischer monatlicher Betrag</h4>
                                  </td>
                                  <td>
                                      <div class="price">${formatNumber(((consumption * (averageAllInPrice / 100)) / 12 + baseFeeGross), true)} €</div>
                                  </td>
                              </tr>
                          </table>
                      </div>`;
            } else if($this.currentStromsteuerTariff) {
                tablesHtml = `<table>
                          <tr>
                              <td>Energiepreis netto <br> <small>(Regulärer Preis)</small></td>
                              <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Stromsteuer-Gutschrift <br> <small>(grüüün für 10 Jahre)</small></td>
                              <td><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Energiepreis netto <br> <small>(inkl. Bonus und 10 Jahre Garantie)</small></td>
                              <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                              <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Arbeitspreis gesamt</td>
                              <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                          </tr>
                      </table>
                      
                      <div class="total">
                          <table>
                              <tr>
                                  <td>
                                      <h4>Du zahlst monatlich insgesamt</h4>
                                  </td>
                                  <td>
                                      <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                                  </td>
                              </tr>
                          </table>
                      </div>`;
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                tablesHtml = `<table>
                          <tr>
                              <td>Energiepreis netto <br> <small>(${years} Jahre Garantie)</small></td>
                              <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                              <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Arbeitspreis gesamt</td>
                              <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                          </tr>
                      </table>
                      
                      <div class="total">
                          <table>
                              <tr>
                                  <td>
                                      <h4>Du zahlst monatlich insgesamt</h4>
                                  </td>
                                  <td>
                                      <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                                  </td>
                              </tr>
                          </table>
                      </div>`;
            } else if($this.currentSofortSparenOhneBonusTariff) {
                tablesHtml = `<table>
                          <tr>
                              <td>Energiepreis netto <br> <small>(Regulärer Preis)</small></td>
                              <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                              <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Arbeitspreis gesamt</td>
                              <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                          </tr>
                      </table>

                      <div class="total">
                          <table>
                              <tr>
                                  <td>
                                      <h4>Du zahlst monatlich insgesamt</h4>
                                  </td>
                                  <td>
                                      <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                                  </td>
                              </tr>
                          </table>
                      </div>`;
            } else {
                tablesHtml = `<table>
                          <tr>
                              <td>Energiepreis netto <br> <small>(Regulärer Preis)</small></td>
                              <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>${bonusPercentage}% grüüün Bonus <br> <small>(grüüün für ${years} Jahre)</small></td>
                              <td><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Energiepreis netto <br> <small>(inkl. Bonus und ${years} Jahre Garantie)</small></td>
                              <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                          </tr>
                          <tr>
                              <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                              <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                          </tr>
                          <tr class="-red">
                              <td>Arbeitspreis gesamt</td>
                              <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                          </tr>
                      </table>
                      
                      <div class="total">
                          <table>
                              <tr>
                                  <td>
                                      <h4>Du zahlst monatlich insgesamt</h4>
                                  </td>
                                  <td>
                                      <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                                  </td>
                              </tr>
                          </table>
                      </div>`;
            }

            return `
                  <div class="tariff-total-info">
                      <h2>
                          Gesamtpreis
                          <a href="#tooltip-tariff-price" class="tooltip-icon"></a>
                      </h2>
                      <table class="bordered">
                          <tr>
                              <td>Jahresverbrauch</td>
                              <td><b>${formatNumber(consumption)} kWh</b></td>
                          </tr>
                          <tr>
                              <td>Mindestlaufzeit</td>
                              <td><b>${runtimeInMonthText}</b></td>
                          </tr>
                      </table>
                      
                      <h4>Grundgebühr <a href="#tooltip-tariff-base-fee-${tariff_id}" class="tooltip-icon"></a></h4>
                      <table class="bordered">
                          <tr>
                              <td>Unsere Grundgebühr<br> <small>${unsereGebuhrTextSmall}</small></td>
                              <td><b>${formatNumber(unsereGebuhr, true)} €</b> / Monat</td>
                          </tr>
                          <tr>
                              <td>Messstellen- / Netzbetreiber <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                              <td><b>${formatNumber((baseFeeGross - unsereGebuhr), true)} €</b> / Monat</td>
                          </tr>
                          <tr class="-red">
                              <td>Grundpreis gesamt</td>
                              <td><b>${formatNumber(baseFeeGross, true)} €</b> / Monat</td>
                          </tr>
                      </table>
      
                      <h4>Arbeitspreis <a href="#tooltip-tariff-electricity-price-${tariff_id}" class="tooltip-icon"></a></h4>
                      ${tablesHtml}
                  </div>
                `;
        }

        function renderTooltipPrice(id, titlePriceModal, textPriceModal, consumption, energyPriceUpTo1000kwh, upto1000kwh, energyPriceUpFrom1001kwh, totalChargesPerKwHInEuro, totalExpensesCostPerKwH, totalExpensesCostPerKwHInEuro, baseFee, baseFeeGross, networkOperatorBaseFee, totalCostPerYear, runtimeInMonth, totalCostPerMonth, bottomTextPriceModal, totalExpensesCostPerYear, energyPriceNet, energyPriceGross, energiepreis, unsereGebuhr, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, bonusPercentage, priceTotals) {
            let popupId = id ? 'tooltip-tariff-price-' + id : 'tooltip-tariff-price';
            let tablesHtml;

            if($this.minifiedOverview) return '';

            if($this.currentBusinessTariff) {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Energiepreis netto (regulär)</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>${bonusPercentage}% grüüün Bonus</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(gruuunBonus, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * gruuunBonus) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Netzentgelte, Steuern, Gebühren</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                                                    <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="total-table-brutto">
                                                <tr>
                                                    <td>Jährlicher Betrag Brutto</td>
                                                    <td>Preise inkl. 19% Umsatzsteuer.</td>
                                                    <td>${formatBusinessPrice(priceTotals.yearlyGross, id, 'totalCostPerYear')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Monatlicher Betrag Brutto</td>
                                                    <td>Preise inkl. 19% Umsatzsteuer.</td>
                                                    <td>${formatBusinessPrice(priceTotals.monthlyGross, id, 'totalCostPerMonth')}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="total-table-netto">
                                            <div class="total-table-netto-row">
                                                <div class="total-table-netto-label">Jährlicher Betrag Netto</div>
                                                <div class="total-table-netto-value">${formatBusinessPrice(priceTotals.yearlyNet, id, 'totalCostPerYearNet')}</div>
                                            </div>
                                            <div class="total-table-netto-row">
                                                <div class="total-table-netto-label">Monatlicher Betrag Netto</div>
                                                <div class="total-table-netto-value">${formatBusinessPrice(priceTotals.monthlyNet, id, 'totalCostPerMonthNet')}</div>
                                            </div>
                                        </div>`;
            } else if($this.currentDynamicTariff) {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(averageAllInPrice, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * averageAllInPrice) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="pretotal-table">
                                                <tr>
                                                    <td>Jährlicher Betrag</td>
                                                    <td>${formatNumber((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))), true)} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <table class="total-table">
                                            <tr>
                                                <td>Monatlicher Betrag:</td>
                                                <td>${formatNumber((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))), true)} € / ${runtimeInMonth} Monate</td>
                                                <td>${formatNumber(((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))) / 12), true)} €</td>
                                            </tr>
                                        </table>`;
            } else if($this.currentStromsteuerTariff) {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Energiepreis netto (regulär)</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Stromsteuer-Gutschrift</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(gruuunBonus, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * gruuunBonus) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Netzentgelte, Steuern, Gebühren</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                                                    <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="pretotal-table">
                                                <tr>
                                                    <td>Jährlicher Betrag</td>
                                                    <td>${formatNumber(totalCostPerYear, true)} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <table class="total-table">
                                            <tr>
                                                <td>Monatlicher Betrag:</td>
                                                <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                                                <td>${formatNumber(totalCostPerMonth, true)} €</td>
                                            </tr>
                                        </table>`;
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Energiepreis netto</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Netzentgelte, Steuern, Gebühren</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                                                    <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="pretotal-table">
                                                <tr>
                                                    <td>Jährlicher Betrag</td>
                                                    <td>${formatNumber(totalCostPerYear, true)} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <table class="total-table">
                                            <tr>
                                                <td>Monatlicher Betrag:</td>
                                                <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                                                <td>${formatNumber(totalCostPerMonth, true)} €</td>
                                            </tr>
                                        </table>`;
            } else if($this.currentSofortSparenOhneBonusTariff) {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Energiepreis netto (regulär)</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Netzentgelte, Steuern, Gebühren</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                                                    <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="pretotal-table">
                                                <tr>
                                                    <td>Jährlicher Betrag</td>
                                                    <td>${formatNumber(totalCostPerYear, true)} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <table class="total-table">
                                            <tr>
                                                <td>Monatlicher Betrag:</td>
                                                <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                                                <td>${formatNumber(totalCostPerMonth, true)} €</td>
                                            </tr>
                                        </table>`;
            } else {
                tablesHtml = `<div class="cost-table-box">
                                            <table class="main-table">
                                                <tr>
                                                    <td>Energiepreis netto (regulär)</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>${bonusPercentage}% grüüün Bonus</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber(gruuunBonus, true)}  ct / kWh</td>
                                                    <td>${formatNumber(((consumption * gruuunBonus) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Netzentgelte, Steuern, Gebühren</td>
                                                    <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                                                    <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Unsere Grundgebühr</td>
                                                   <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                                                    <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                                                </tr>
                                                <tr>
                                                    <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                                                    <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                                                    <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                                                </tr>
                                            </table>
                                            <table class="pretotal-table">
                                                <tr>
                                                    <td>Jährlicher Betrag</td>
                                                    <td>${formatNumber(totalCostPerYear, true)} €</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <table class="total-table">
                                            <tr>
                                                <td>Monatlicher Betrag:</td>
                                                <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                                                <td>${formatNumber(totalCostPerMonth, true)} €</td>
                                            </tr>
                                        </table>`;
            }
            return `
                  <div class="tooltip-popup -bigger" id="${popupId}">
                                <div class="modal-overlay"></div>
                                <div class="modal-box scroll-container">
                                    <div class="modal-content">
                                        <div class="close-button"></div>
                                        <h3>${titlePriceModal}</h3>
                                        ${textPriceModal}
                                        <h4>${$this.currentBusinessTariff ? 'Verbrauchskosten' : 'Verbrauchskostenschätzung'} <span style="color: #B5AAAA;">bei ${formatNumber(consumption)} kWh / Jahr</span></h4>
                                        ${tablesHtml}
                                        ${$this.currentBusinessTariff ? '' : `<div class="hint -right">${bottomTextPriceModal}</div>`}
                                    </div>
                                </div>
                            </div>
                `;
        }

        function renderTooltipBaseFee(id, titleBaseFeeModal, baseFeeGross, totalExpensesCostPerYear, bottomTextBaseFeeModal, textBaseFeeModal, totalChargesPerKwHInEuro, unsereGebuhr) {
            let unsereGebuhrTextSmall = $this.currentDynamicTariff || $this.currentLightTariff || $this.currentFreundeTariff || $this.currentGemeindestromTariff || $this.currentSonnenregionErzgebirgeTariff || $this.currentBusinessTariff || $this.currentSofortSparenOhneBonusTariff ? `` : `(10 Jahre Garantie)`;
            return `
                 <div class="tooltip-popup -bigger" id="tooltip-tariff-base-fee-${id}">
                                <div class="modal-overlay"></div>
                                <div class="modal-box scroll-container">
                                    <div class="modal-content">
                                        <div class="close-button"></div>
                                        <h3>${titleBaseFeeModal}</h3>
                                        <div class="flex-box">
                                            <div class="cost-table-min-box">
                                                <div class="cost-table-min">
                                                    <table class="main-table">
                                                        <tr>
                                                            <td>Unsere Grundgebühr <small>${unsereGebuhrTextSmall}</small></td>
                                                            <td><b>${formatNumber(unsereGebuhr, true)} €</b> / Monat</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Grundgebühr Netz-/ Messstellenbetreiber <small>(Darauf haben wir keinen Einfluss)</small></td>
                                                            <td><b>${formatNumber((baseFeeGross - unsereGebuhr), true)} € </b>/ Monat</td>
                                                        </tr>
                                                    </table>
                                                    <table class="pretotal-table">
                                                        <tr>
                                                            <td>Grundpreis (brutto)</td>
                                                            <td><b>${formatNumber(baseFeeGross, true)} €</b> / Monat</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="right-text">
                                                ${textBaseFeeModal}
                                            </div>
                                        </div>
                                        <div class="hint -min-margin">${bottomTextBaseFeeModal}</div>
                                    </div>
                                </div>
                            </div>`;
        }

        function renderTooltipElectricityPrice(id, titleElectricityPriceModal, upto1000kwh, totalChargesPerKwHInEuro, totalExpensesCostPerKwHInEuro, bottomTextElectricityPriceModal, textElectricityPriceModal, energyPriceGross, energyPriceNet, energiepreis, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, bonusPercentage) {
            let tableElectricity;

            let years = '10';

            if($this.currentBusinessTariff) {
                years = '3';
            } else if($this.currentFreundeTariff) {
                years = '5';
            } else if($this.currentGemeindestromTariff) {
                years = '6';
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                years = '20';
            }

            if($this.currentDynamicTariff) {
                tableElectricity = `<div class="electricity-table-box">
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">Regulärer Preis</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>dynamischer EPEX Preis</b></td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">Netzentgelte, Steuern, Gebühren, Umlagen</th>
                                                        </tr>
                                                        <tr>
                                                            <td>für jede kWh</td>
                                                            <td><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <td>Durchschnittlicher Arbeitspreis des letzten Kalendermonats</td>
                                                            <td><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
                                            </div>`;
            } else if($this.currentStromsteuerTariff){
                tableElectricity = `<div class="electricity-table-box">
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">Regulärer Preis</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">grüüün für 10 Jahre</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Stromsteuer-Gutschrift</td>
                                                            <td><b>${formatNumber(gruuunBonus, true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">inkl. Gutschrift und 10 Jahre Garantie</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">Netzentgelte, Steuern, Gebühren</th>
                                                        </tr>
                                                        <tr>
                                                            <td>für jede kWh</td>
                                                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <td>Arbeitspreis gesamt</td>
                                                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
                                            </div>`;
            } else if($this.currentSonnenregionErzgebirgeTariff || $this.currentSofortSparenOhneBonusTariff){
                tableElectricity = `<div class="electricity-table-box">
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">Regulärer Preis</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">Netzentgelte, Steuern, Gebühren</th>
                                                        </tr>
                                                        <tr>
                                                            <td>für jede kWh</td>
                                                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <td>Arbeitspreis gesamt</td>
                                                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
                                            </div>`;
            } else {
                tableElectricity = `<div class="electricity-table-box">
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">Regulärer Preis</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">grüüün für ${years} Jahre</th>
                                                        </tr>
                                                        <tr>
                                                            <td>${bonusPercentage}% grüüün Bonus</td>
                                                            <td><b>${formatNumber(gruuunBonus, true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <th colspan="2">inkl. Bonus und ${years} Jahre Garantie</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Energiepreis netto</td>
                                                            <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-total-table">
                                                    <table>
                                                        <tr>
                                                            <th colspan="2">Netzentgelte, Steuern, Gebühren</th>
                                                        </tr>
                                                        <tr>
                                                            <td>für jede kWh</td>
                                                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="electricity-table">
                                                    <table class="main-table">
                                                        <tr>
                                                            <td>Arbeitspreis gesamt</td>
                                                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                ${$this.currentBusinessTariff ? '' : `<div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>`}
                                            </div>`;
            }
            return `
                  <div class="tooltip-popup -bigger" id="tooltip-tariff-electricity-price-${id}">
                                <div class="modal-overlay"></div>
                                <div class="modal-box scroll-container">
                                    <div class="modal-content">
                                        <div class="close-button"></div>
                                        <h3>${titleElectricityPriceModal}</h3>
                                        <div class="flex-box">
                                            ${tableElectricity}
                                            <div class="right-text">
                                                ${textElectricityPriceModal}
                                            </div>
                                        </div>
                                        ${$this.currentBusinessTariff ? `<div class="hint -vat-note">Preise inkl. 19% Umsatzsteuer.</div>` : ''}
                                    </div>
                                </div>
                            </div>
                            
                `;
        }

        function renderTooltipTariffInfo(id, nameExtern, contentTariffDetailsModal) {
            return ` <div class="tooltip-popup -bigger" id="tooltip-tariff-info-${id}">
                                <div class="modal-overlay"></div>
                                <div class="modal-box scroll-container">
                                    <div class="modal-content">
                                        <div class="close-button"></div>
                                        <h3 class="tariff-title">Tarifdetails <span style="color: #b5aaaa">${nameExtern}</span></h3>
                                        ${contentTariffDetailsModal}
                                    </div>
                                </div>
                            </div>`;
        }

        function renderMainTariffHtml(id, classBadge, nameExtern, totalCostPerMonth, runtimeInMonth, energyPriceGross, FORM_URL, energiepreis, unsereGebuhr, baseFeeGross, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, consumption, bonusPercentage, priceTotals) {
            let topBox;
            let priceBox;
            let subtitle;
            let years = '10';

            if($this.currentBusinessTariff) {
                years = '3';
            } else if($this.currentFreundeTariff) {
                years = '5';
            } else if($this.currentGemeindestromTariff) {
                years = '6';
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                years = '20';
            }

            let unsereGebuhrTextSmall = $this.currentDynamicTariff || $this.currentLightTariff || $this.currentFreundeTariff || $this.currentGemeindestromTariff || $this.currentSonnenregionErzgebirgeTariff || $this.currentBusinessTariff || $this.currentSofortSparenOhneBonusTariff ? ``:`(${years} Jahre Garantie)`;

            if($this.currentBusinessTariff) {
                topBox = `<div class="badge">Business Tarif</div>
                          <div class="top-box">
                          ${$this.minifiedOverview?
                              `<h2 class="tariff-title">${nameExtern}</h2>` :
                              `<h4 class="tariff-title">${nameExtern}</h4>
                                <div class="price-business">
                                    <div class="price-business-col -gross">
                                        <div class="price-business-value">${formatBusinessPrice(priceTotals.monthlyGross, id, 'totalCostPerMonth')}</div>
                                        <div class="price-business-label">Monat (Brutto)</div>
                                    </div>
                                    <div class="price-business-col -net">
                                        <div class="price-business-value">${formatBusinessPrice(priceTotals.monthlyNet, id, 'totalCostPerMonthNet')}</div>
                                        <div class="price-business-label">Monat (Netto)</div>
                                    </div>
                                </div>
                                <div class="under-price-row">
                                    <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>
                                    <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a>
                                </div>`
                          }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">${bonusPercentage}% grüüün Bonus <small>(grüüün für ${years} Jahre)</small></div>
                                    <div class="right-part"><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und ${years} Jahre Garantie)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Abschlag zusammen:`;
            } else if($this.currentDynamicTariff) {
                topBox = `<div class="badge">Dynamischer Tarif</div>
                          <div class="top-box">
                              ${$this.minifiedOverview? 
                                `<h2 class="tariff-title">${nameExtern}</h2>` :
                                `<h4 class="tariff-title">${nameExtern}</h4>
                                    <div class="price"><span>${formatNumber(((consumption * (averageAllInPrice / 100)) / 12 + baseFeeGross), true)} €</span> / Monat <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                                    <div class="under-price-text">Monatlich kündbar</div>`
                              }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(stundenaktuell EPEX Börsenpreis)</small></div>
                                    <div class="right-part">Dynamischer Preis</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Weitere Preisbestandteile <small>(Umlagen, Netzentgelte, Steuern, Gebühren)</small></div>
                                    <div class="right-part"><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</div>
                                    <div class="right-part"><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Preis zusammen:`;
            } else if($this.currentStromsteuerTariff) {
                topBox = `<div class="badge">Stromsteuer geschenkt</div>
                          <div class="top-box">
                            ${$this.minifiedOverview?
                              `<h2 class="tariff-title">${nameExtern}</h2>` :
                              `<h4 class="tariff-title">${nameExtern}</h4>
                                <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                                <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>`
                            }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Stromsteuer-Gutschrift <small>(grüüün für 10 Jahre)</small></div>
                                    <div class="right-part"><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und 10 Jahre Garantie)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Abschlag zusammen:`;
            } else if($this.currentSonnenregionErzgebirgeTariff) {
                topBox = `<div class="badge">Beste Wahl</div>
                          <div class="top-box">
                            ${$this.minifiedOverview?
                              `<h2 class="tariff-title">${nameExtern}</h2>` :
                              `<h4 class="tariff-title">${nameExtern}</h4>
                                <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                                <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>`
                            }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(${years} Jahre Garantie)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Abschlag zusammen:`;
            } else if($this.currentSofortSparenOhneBonusTariff) {
                topBox = `<div class="badge">100% Ökostrom</div>
                          <div class="top-box">
                          ${$this.minifiedOverview?
                              `<h2 class="tariff-title">${nameExtern}</h2>` :
                              `<h4 class="tariff-title">${nameExtern}</h4>
                                <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                                <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>`
                          }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Abschlag zusammen:`;
            } else {
                topBox = `<div class="badge">${bonusPercentage}% geschenkt!</div>
                          <div class="top-box">
                          ${$this.minifiedOverview?
                              `<h2 class="tariff-title">${nameExtern}</h2>` :
                              `<h4 class="tariff-title">${nameExtern}</h4>
                                <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                                <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>`
                          }
                          </div>`;
                priceBox = `<div class="info-box">
                                <div class="info-title">Arbeitspreis <a href="#tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">${bonusPercentage}% grüüün Bonus <small>(grüüün für ${years} Jahre)</small></div>
                                    <div class="right-part"><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und ${years} Jahre Garantie)</small></div>
                                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                                </div>
                            </div>`;
                subtitle = `So setzt sich Dein Abschlag zusammen:`;
            }

            return `<div class="tariff-info ${classBadge}" id="price-info-${id}">
                        ${topBox}
                        <form id="tariff-form-${id}" action="${$this.getTariffFormUrl()}" method="post" style="display: none;">
                            <input type="hidden" name="encodedData" value="">
                        </form>
                        
                        <div class="button-box">
                            <button class="btn" id="choose-tariff-btn-${id}" disabled>
                                ${$this.minifiedOverview ? 'Angebot anfordern':'Tarif buchen'}
                            </button>
                        </div>
                        
                        <div class="text-2 bold">${subtitle}</div>
                                                        
                        <div class="info-boxes">
                            ${priceBox}
                            <div class="info-box">
                                <div class="info-title">Grundgebühr <a href="#tooltip-tariff-base-fee-${id}" class="tooltip-icon"></a></div>
                                <div class="item">
                                    <div class="left-part">Unsere Gebühr <small>${unsereGebuhrTextSmall}</small></div>
                                    <div class="right-part"><b>${formatNumber(unsereGebuhr, true)} €</b> / Monat</div>
                                </div>
                                <div class="item">
                                    <div class="left-part">Messstellen-/ Netzbetreiber <small>(Darauf haben wir keinen Einfluss)</small></div>
                                    <div class="right-part"><b>${formatNumber((baseFeeGross - unsereGebuhr), true)} €</b> / Monat</div>
                                </div>
                                <div class="item -red">
                                    <div class="left-part">Grundpreis (brutto) gesamt</div>
                                    <div class="right-part"><b>${formatNumber(baseFeeGross, true)} €</b> / Monat</div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-link">
                            <a href="#tooltip-tariff-info-${id}" class="btn-link-primary arrow-right tooltip-link">Tarifdetails</a>
                        </div>
                    </div>`;
        }

        function renderMultistepSidebar(id, nameExtern, totalCostPerMonth, shortDescription, shortDescriptionAdditional, showShortDescriptionAdditional, averageAllInPrice, baseFeeGross, consumption, bonusPercentage, priceTotals) {
            let showShortDescObj = {};
            if(showShortDescriptionAdditional) {
                try {
                    showShortDescObj = JSON.parse(showShortDescriptionAdditional);
                } catch (e) {
                    console.error('JSON error:', e);
                }
            }


            let totalCostPerMonthText = $this.currentDynamicTariff ? `${formatNumber(((consumption * (averageAllInPrice / 100)) / 12 + baseFeeGross), true)} €`:`${formatNumber(totalCostPerMonth, true)} €`;
            let shouldShowAdditional = false;

            if (Array.isArray(showShortDescObj) && showShortDescObj.length > 0) {
                if (showShortDescObj.includes('dynamic') && $this.currentDynamicTariff) {
                    shouldShowAdditional = true;
                } else if (showShortDescObj.includes('friends') && $this.currentFriendsAndFamilyTariff) {
                    shouldShowAdditional = true;
                } else if (showShortDescObj.includes('stromsteuer') && $this.currentStromsteuerTariff) {
                    shouldShowAdditional = true;
                } else if (showShortDescObj.includes('light') && $this.currentLightTariff) {
                    shouldShowAdditional = true;
                } else if (showShortDescObj.includes('erzgebirge') && $this.currentSonnenregionErzgebirgeTariff) {
                    shouldShowAdditional = true;
                } else if (showShortDescObj.includes('default') && $this.currentDefaultTariff) {
                    shouldShowAdditional = true;
                }
            }

            return ` 
                <div class="tariff-info">
                  <div class="back-link"><a href="javascript:history.back()" class="btn-primary">zurück</a></div>
                  <div class="main-info">
                    <h3 class="title">Dein Tarif</h3>
                    <h4 class="subtitle">
                      ${nameExtern}
                      <a href="#tooltip-tariff-price" class="tooltip-icon"></a>
                    </h4>
                    ${$this.currentBusinessTariff ? `
                    <div class="price -business">
                      <div class="price-row -gross">
                        <span>${formatBusinessPrice(priceTotals.monthlyGross, id, 'totalCostPerMonth')}</span> /Monat (brutto)
                      </div>
                      <div class="price-row -net">
                        <span>${formatBusinessPrice(priceTotals.monthlyNet, id, 'totalCostPerMonthNet')}</span> /Monat (netto)
                      </div>
                    </div>
                    ` : `
                    <div class="price">
                      <span>${totalCostPerMonthText}</span>
                      /Monat
                    </div>
                    `}
                    <div class="details-link">
                        <a href="#tooltip-tariff-info-${id}"
                         class="tooltip-link btn-primary"> Tarifdetails</a>
                    </div>
                  </div>
                  <div class="info-list">${shortDescription}</div>
                  
                  ${shouldShowAdditional ? `<div class="info-list -white-bullets">${shortDescriptionAdditional}</div>` : ''}
                </div>          
            `;
        }

        if (data && data.priceInformation && data.priceInformation.length > 0) {
            // Initialize an array to hold the HTML content for each tariff
            let priceInfoHtmlArray = [];
            let $this = this;

            // Iterate over each tariff and make AJAX requests for additional information
            const ajaxPromises = data.priceInformation.map(tariffInfo => {
                const {tariff, priceCalculation, additionalCalculationData} = tariffInfo;
                const {nameExtern, energyPriceGross, energyPriceNet, baseFeeGross, runtimeInMonth} = tariff;
                const {totalCostPerMonth, totalCostPerYear, totalCostPerMonthNet, totalCostPerYearNet} = priceCalculation;
                const priceTotals = {
                    monthlyGross: totalCostPerMonth,
                    monthlyNet: totalCostPerMonthNet,
                    yearlyGross: totalCostPerYear,
                    yearlyNet: totalCostPerYearNet,
                };
                const {expectedPaymentPlanPerMonth} = additionalCalculationData[0];
                const totalChargesPerKwH = tariffInfo.charges.totalChargesPerKwH;

                const totalChargesPerKwHInEuro = totalChargesPerKwH / 100;
                const totalExpensesCostPerKwH = data.expenses.totalExpensesCostPerKwH || 0;
                const totalExpensesCostPerKwHInEuro = totalExpensesCostPerKwH / 100;
                const totalExpensesCostPerYear = data.expenses.totalExpensesCostPerYear || 0;

                function ajaxRequestAsPromise(requestData) {
                    return new Promise((resolve, reject) => {
                        $.ajax({
                            url: myajax.url,
                            method: 'POST',
                            data: requestData,
                            success(response) {
                                if(!response.success) {
                                    reject(new Error(response.data));
                                }
                                resolve(response);
                            },
                            error(jqXHR, textStatus, errorThrown) {
                                reject(new Error('AJAX error: ' + textStatus + ' - ' + errorThrown));
                            }
                        });
                    });
                }

                return ajaxRequestAsPromise({
                    action: 'get_additional_tariff_info',
                    city,
                    postalCode,
                    page_id: myajax.page_id,
                    tariff_id: tariff.id,
                    dynamic: this.currentDynamicTariff,
                    nonce: myajax.nonces.get_additional_tariff_info
                }).then(response => {
                    if (response.data && !response.data.error) {
                        const orderIndex = response.data.orderIndex;
                        const upto1000kwh = response.data.upto1000kwh;
                        const badgeBest = response.data.badgeBest;
                        const classBadge = badgeBest ? '-main' : '';
                        const titlePriceModal = response.data.titlePriceModal;
                        const textPriceModal = response.data.textPriceModal;
                        const bottomTextPriceModal = response.data.bottomTextPriceModal;
                        const energyPriceUpTo1000kwh = response.data.energyPriceUpTo1000kwh;
                        const energyPriceUpFrom1001kwh = response.data.energyPriceUpFrom1001kwh;
                        const baseFee = response.data.baseFee;
                        const networkOperatorBaseFee = response.data.networkOperatorBaseFee;
                        const titleBaseFeeModal = response.data.titleBaseFeeModal;
                        const textBaseFeeModal = response.data.textBaseFeeModal;
                        const bottomTextBaseFeeModal = response.data.bottomTextBaseFeeModal;
                        const titleElectricityPriceModal = response.data.titleElectricityPriceModal;
                        const textElectricityPriceModal = response.data.textElectricityPriceModal;
                        const bottomTextElectricityPriceModal = response.data.bottomTextElectricityPriceModal;
                        const contentTariffDetailsModal = response.data.contentTariffDetailsModal;
                        const shortDescription = response.data.shortDescription;
                        const shortDescriptionAdditional = response.data.shortDescriptionAdditional;
                        const showShortDescriptionAdditional = response.data.showShortDescriptionAdditional;
                        const energiepreis = response.data.energiepreis;
                        const unsereGebuhr = response.data.unsereGebuhr;
                        const gruuunBonus = response.data.gruuunBonus;
                        const bonusPercentage = response.data.bonusPercentage;
                        const energiepreisPlusBonus = response.data.energiepreisPlusBonus;
                        const shortDescriptionComparison = response.data.shortDescriptionComparison;
                        const garantieAufEnergie = response.data.garantieAufEnergie;
                        const grunstromAusDeutschland = response.data.grunstromAusDeutschland;
                        const mindestVertragslaufzeit = response.data.mindestVertragslaufzeit;
                        const kundigungsfrist = response.data.kundigungsfrist;
                        const enableBadge = response.data.enableBadge;
                        const averageAuctionPrice = response.data.averageAuctionPrice ? parseFloat(response.data.averageAuctionPrice) : 0;
                        const averageAllInPrice = response.data.averageAllInPrice ? parseFloat(response.data.averageAllInPrice) : 0;

                        const tooltipPriceHtml = renderTooltipPrice(tariff.id, titlePriceModal, textPriceModal, consumption, energyPriceUpTo1000kwh, upto1000kwh, energyPriceUpFrom1001kwh, totalChargesPerKwHInEuro, totalExpensesCostPerKwH, totalExpensesCostPerKwHInEuro, baseFee, baseFeeGross, networkOperatorBaseFee, totalCostPerYear, runtimeInMonth, totalCostPerMonth, bottomTextPriceModal, totalExpensesCostPerYear, energyPriceNet, energyPriceGross, energiepreis, unsereGebuhr, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, bonusPercentage, priceTotals);
                        const tooltipPriceHtmlWithoutId = renderTooltipPrice('', titlePriceModal, textPriceModal, consumption, energyPriceUpTo1000kwh, upto1000kwh, energyPriceUpFrom1001kwh, totalChargesPerKwHInEuro, totalExpensesCostPerKwH, totalExpensesCostPerKwHInEuro, baseFee, baseFeeGross, networkOperatorBaseFee, totalCostPerYear, runtimeInMonth, totalCostPerMonth, bottomTextPriceModal, totalExpensesCostPerYear, energyPriceNet, energyPriceGross, energiepreis, unsereGebuhr, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, bonusPercentage, priceTotals);
                        const tooltipBaseFeeHtml = renderTooltipBaseFee(tariff.id, titleBaseFeeModal, baseFeeGross, totalExpensesCostPerYear, bottomTextBaseFeeModal, textBaseFeeModal, totalChargesPerKwHInEuro, unsereGebuhr);
                        const tooltipElectricityPriceHtml = renderTooltipElectricityPrice(tariff.id, titleElectricityPriceModal, upto1000kwh, totalChargesPerKwHInEuro, totalExpensesCostPerKwHInEuro, bottomTextElectricityPriceModal, textElectricityPriceModal, energyPriceGross, energyPriceNet, energiepreis, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, bonusPercentage);
                        const tooltipTariffInfoHtml = renderTooltipTariffInfo(tariff.id, nameExtern, contentTariffDetailsModal);
                        const Step4TableTotalPrice = renderStep4TableTotalPrice(tariff.id, consumption, runtimeInMonth, baseFeeGross, totalExpensesCostPerYear, upto1000kwh, totalExpensesCostPerKwHInEuro, totalChargesPerKwHInEuro, totalCostPerMonth, energyPriceNet, energyPriceGross, energiepreis, unsereGebuhr, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, bonusPercentage);
                        const mainTariffHtml = renderMainTariffHtml(tariff.id, classBadge, nameExtern, totalCostPerMonth, runtimeInMonth, energyPriceGross, FORM_URL, energiepreis, unsereGebuhr, baseFeeGross, gruuunBonus, energiepreisPlusBonus, averageAllInPrice, averageAuctionPrice, consumption, bonusPercentage, priceTotals);

                        const multistepSidebar = renderMultistepSidebar(tariff.id, nameExtern, totalCostPerMonth, shortDescription, shortDescriptionAdditional, showShortDescriptionAdditional, averageAllInPrice, baseFeeGross, consumption, bonusPercentage, priceTotals);

                        const priceInfoHtml = `
                        
                            ${mainTariffHtml}
                            ${tooltipPriceHtml}
                            ${tooltipBaseFeeHtml}
                            ${tooltipElectricityPriceHtml}
                            ${tooltipTariffInfoHtml}
                           
                        `;


                        // priceInfoHtmlArray.push(priceInfoHtml);
                        const selectedTariff = data.priceInformation.find(tariffInfo => tariffInfo.tariff.id === tariff.id);

                        // Encode combined data for the form
                        const combinedData = {
                            priceInfo: selectedTariff,
                            upto1000kwh: upto1000kwh,
                            consumption,
                            postalCode,
                            city,
                            street,
                            houseNumber,
                            secretKey,
                            referralContractNumber,
                            tooltipPriceHtmlWithoutId: tooltipPriceHtmlWithoutId,
                            shortDescription: shortDescription,
                            tooltipPriceHtml: tooltipPriceHtml,
                            tooltipTariffInfoHtml: tooltipTariffInfoHtml,
                            Step4TableTotalPrice: Step4TableTotalPrice,
                            tooltipBaseFeeHtml: tooltipBaseFeeHtml,
                            tooltipElectricityPriceHtml: tooltipElectricityPriceHtml,
                            multistepSidebar: multistepSidebar
                        };
                        const jsonString = JSON.stringify(combinedData);
                        const encodedData = btoa(unescape(encodeURIComponent(jsonString)));

                        // Return an object with tariff id and encoded data for later processing
                        return {
                            id: tariff.id,
                            orderIndex: orderIndex,
                            tariff,
                            priceCalculation,
                            additionalCalculationData,
                            nameExtern,
                            classBadge,
                            badgeBest,

                            totalCostPerMonth,
                            totalCostPerYear,
                            expectedPaymentPlanPerMonth,
                            runtimeInMonth,
                            energyPriceGross,
                            energyPriceNet,
                            baseFeeGross,

                            totalChargesPerKwHInEuro,
                            totalExpensesCostPerKwHInEuro,
                            totalExpensesCostPerYear,

                            upto1000kwh,
                            shortDescription,
                            shortDescriptionAdditional,
                            showShortDescriptionAdditional,

                            energiepreis,
                            gruuunBonus,
                            bonusPercentage,
                            energiepreisPlusBonus,
                            unsereGebuhr,
                            averageAuctionPrice,
                            averageAllInPrice,

                            shortDescriptionComparison,
                            garantieAufEnergie,
                            grunstromAusDeutschland,
                            mindestVertragslaufzeit,
                            kundigungsfrist,
                            enableBadge,

                            tooltipPriceHtml,
                            tooltipPriceHtmlWithoutId,
                            tooltipBaseFeeHtml,
                            tooltipElectricityPriceHtml,
                            tooltipTariffInfoHtml,
                            Step4TableTotalPrice,
                            mainTariffHtml,
                            multistepSidebar,

                            encodedData
                        };
                    }
                    return null;
                });
            });

            // After all AJAX requests are completed, update the HTML
            Promise.all(ajaxPromises).then(results => {
                const matchedTariffs = results.filter(Boolean);

                matchedTariffs.sort((a, b) => {
                    const firstOrder = Number.isInteger(Number(a.orderIndex)) ? Number(a.orderIndex) : 999;
                    const secondOrder = Number.isInteger(Number(b.orderIndex)) ? Number(b.orderIndex) : 999;

                    return firstOrder - secondOrder;
                });

                if (!matchedTariffs.length) {
                    $(SELECTORS.PRICE_INFO_CONTAINER).html(`
                        <div class="error-wrapper text-3">
                            <p>Kein Tarif gefunden.</p>
                        </div>
                    `);

                    setTimeout(() => {
                        this.scrollToElement($(SELECTORS.PRICE_INFO_CONTAINER));
                    }, 100);

                    this.hideLoader();
                    this.loading = false;

                    return;
                }

                if (matchedTariffs.length === 1) {
                    $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER)
                        .removeClass('-comparison-mode')
                        .children('.tariff-general-info')
                        .show();

                    $(SELECTORS.PRICE_INFO_CONTAINER)
                        .removeClass('-comparison')
                        .html(matchedTariffs[0].mainTariffHtml + `
                            ${matchedTariffs[0].tooltipPriceHtml}
                            ${matchedTariffs[0].tooltipBaseFeeHtml}
                            ${matchedTariffs[0].tooltipElectricityPriceHtml}
                            ${matchedTariffs[0].tooltipTariffInfoHtml}
                        `);
                } else {
                    $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER)
                        .addClass('-comparison-mode')
                        .children('.tariff-general-info')
                        .hide();

                    $(SELECTORS.PRICE_INFO_CONTAINER)
                        .addClass('-comparison')
                        .html(renderComparisonLayout(matchedTariffs));

                    initComparisonLayout();
                }

                setTimeout(() => {
                    this.scrollToElement($(SELECTORS.PRICE_INFO_CONTAINER));
                }, 100);

                matchedTariffs.forEach(tariffData => {
                    $(`#tariff-form-${tariffData.id} input[name="encodedData"]`).val(tariffData.encodedData);

                    $(`#choose-tariff-btn-${tariffData.id}`).prop('disabled', false).on('click', () => {
                        const tariffFormUrl = this.getTariffFormUrl();

                        $(`#tariff-form-${tariffData.id}`)
                            .attr('action', tariffFormUrl)
                            .submit();
                    });

                    $(`.mobile-choose-tariff[data-tariff-id="${tariffData.id}"]`).on('click', () => {
                        $(`#choose-tariff-btn-${tariffData.id}`).trigger('click');
                    });
                });
                this.setupAiBlock(true);
                this.hideLoader();
                this.loading = false;
            }).catch(error => {
                this.setupAiBlock(false);
                this.hideLoader();
                this.loading = false;
                console.error(error);
                $(SELECTORS.PRICE_INFO_CONTAINER).html(`<div class="error-wrapper text-3"><p>Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.</p></div>`);

                setTimeout(() => {
                    this.scrollToElement($(SELECTORS.PRICE_INFO_CONTAINER));
                }, 100);
            });
        } else {
            // Call enableStreetSelectInPopup and wait until it's completed
            this.enableStreetSelectInPopup().then(() => {
                this.setupAiBlock(false);
                this.hideLoader();
                this.loading = false;
                $(SELECTORS.PRICE_INFO_CONTAINER).html('<div class="error-wrapper text-3"><p> Um Deinen Tarif berechnen zu können, benötigen wir Deine Straße  </p> <a class="btn-primary" id="streetInFirstStep" href="#">Wähle Deine Straße aus</a></div>');

                let $this = this;

                setTimeout(function () {
                    $this.scrollToElement($(SELECTORS.PRICE_INFO_CONTAINER));
                }, 100);

                setTimeout(function () {
                    $(SELECTORS.STREET_POPUP).addClass('showStreet');
                    $('body').addClass('overflow-hidden');
                }, 500);
            });

        }

    }

    setupAiBlock(show) {
        $(SELECTORS.AI_BLOCK).toggleClass('hidden', !show);

        if(show) {
            $(SELECTORS.AI_BLOCK).each( function(i) {
                const lottieCanvasBox = $(this).find('.lottie-canvas');
                const lottieCanvas = lottieCanvasBox.find('canvas');

                if (lottieCanvas.length > 0) {
                    const lottieSrc = lottieCanvas.data('src');
                    const lottieLoop = lottieCanvas.data('loop');

                    const dotLottie = new DotLottie({
                        autoplay: true,
                        loop: lottieLoop,
                        canvas: lottieCanvas[0],
                        src: lottieSrc
                    });
                }
            });
        }
    }

    enableStreetSelectInPopup() {
        return new Promise((resolve) => {
            this.clearForm($(SELECTORS.STREET_POPUP_FORM));

            this.initializeSelect2(SELECTORS.STREET_INPUT_FAKE, { multiple: true, minimumResultsForSearch: 999, maximumSelectionLength: 1 });

            let postalCodeAndOrt = $(SELECTORS.POSTAL_CODE_AND_ORT_SELECT).val();

            if ($.isArray(postalCodeAndOrt)) {
                postalCodeAndOrt = postalCodeAndOrt[0];
            }

            const selectedData = JSON.parse(postalCodeAndOrt);
            const postalCode = selectedData.code;
            const city = selectedData.city;

            // Update select2 data and resolve when complete
            this.updateSelect2Data(postalCode, SELECTORS.STREET_INPUT_FAKE, false, city)
                .then(() => resolve()); // resolve the Promise after updateSelect2Data completes
        });
    }


    // Initialize Default Fields
    initDefaultFieldStepForm2() {

        const defaultFields = {
            'city': this.defaultCity,
            'postalCode': this.defaultPostalCode,
            'housenumber': this.defaultHouseNumnber,
        };

        this.initializeSelect2(SELECTORS.STREET, { multiple: true, minimumResultsForSearch: 999, maximumSelectionLength: 1 });
        this.updateSelect2Data(this.defaultPostalCode, SELECTORS.STREET, this.defaultstreet, this.defaultCity);
        this.attachPostalCodeChangeListener(SELECTORS.STEP_POSTAL_CODE, SELECTORS.STREET);

        // Watch differentAddress checkbox
        this.watchDifferentAddress(SELECTORS.DIFFERENT_ADDRESS_CHECKBOX, SELECTORS.D_STREET, SELECTORS.STEP_D_POSTAL_CODE);

        if (this.currentBusinessTariffMultistep) {
            this.initDeviatingAddressLocationField();
        }

        this.initializeSupplierSelect2(SELECTORS.OLD_SUPPLIER_NAME);

        Object.keys(defaultFields).forEach(field => {
            if(field === 'housenumber') {
                $(`input[name="${field}"]`).val(defaultFields[field]);
            } else {
                $(`input[name="${field}"]`).val(defaultFields[field]).attr('disabled', true);
            }
        });


    }

    // Extract Form Values
    extractFormValues(keys, prefix = '') {
        return keys.reduce((collectedData, key) => {
            const fieldName = `${prefix}${key}`;
            const value = $(`[name="${fieldName}"]`).val();

            const salutationValues = {
                'Herr': '2',
                'Frau': '1',
                'Divers': '5',
                'Familie': '3'
            };

            // Only add the key to collectedData if the value is not undefined, not an empty string,
            // not an empty array, and not an empty object

            if ((fieldName === 'salutation' || fieldName === 'dsalutation') && value !== undefined && value !== "" && salutationValues[value] !== undefined) {
                collectedData[key] = salutationValues[value];
            } else if((fieldName === 'title' || fieldName === 'dtitle') && value && value === 'nullValue') {
                collectedData[key] = null;
            } else if(fieldName === 'dateOfBirth') {
                collectedData[key] = this.convertDate(value, true);
            } else {
                if (
                    value !== undefined &&
                    value !== "" &&
                    !(Array.isArray(value) && value.length === 0) &&
                    !(typeof value === 'object' && Object.keys(value).length === 0)
                ) {
                    collectedData[key] = Array.isArray(value) ? value[0] : value;
                }
            }

            return collectedData;
        }, {});
    }

    // Add Keys to Form Data
    addKeysToFormData(keys, formData) {
        keys.forEach(key => {
            const $target = $(`[name="${key}"]`);
            const value = $target.val();

            // Only add the key to formData if the value is not undefined, not an empty string,
            // not an empty array, and not an empty object
            if (key === 'marketLocation' || key === 'deliveryPointMeteringDeviceNumber') {
                if (value !== undefined) {
                    formData[key] = Array.isArray(value) ? value[0] : value;
                }
            } else if(key === 'supplierOldCancellationDate' || key === 'supplyBeginDate') {
                if (
                    value !== undefined &&
                    value !== ""
                ) {
                    formData[key] = this.convertDate(value, true);
                }
            } else {
                if (
                    value !== undefined &&
                    value !== "" &&
                    !(Array.isArray(value) && value.length === 0) &&
                    !(typeof value === 'object' && Object.keys(value).length === 0)
                ) {
                    formData[key] = Array.isArray(value) ? value[0] : value;
                }
            }

        });
    }

    // Collect Form Data
    collectFormData() {
        if (this.currentBusinessTariffMultistep) {
            this.syncInvoiceEmailFromFakeField({ skipEmpty: true });
        }

        this.formData.tarifId = this.defaultTariff;
        this.formData.consumptionPrognosisKwh = this.defaultConsumption;
        this.formData.section = "Electricity";
        this.formData.supplyChangeCause = this.defaultSupplyChangeCause;
        this.formData.oldSupplierCancellationState = this.defaultOldSupplierCancellationState;
        this.formData.supplierOldCancellationDate = this.defaultSupplierOldCancellationDate;
        this.formData.supplyBeginDateSpecified = this.defaultSupplyBeginDateSpecified;
        this.formData['oldSupplier'] = "";

        let matomoId = document.cookie.split('; ').find(row => /^_pk_id[^=]*=/.test(row)) ? document.cookie.split('; ').find(row => /^_pk_id[^=]*=/.test(row)).split('=')[1] : '';
        let googleId = document.cookie.split('; ').find(row => row.startsWith('_ga='))? document.cookie.split('; ').find(row => row.startsWith('_ga=')).split('=')[1] : '';

        if(matomoId || googleId) {
            this.formData['stringAdditional2'] = `${matomoId}, ${googleId}`;
        }

        if(this.couponCode) {
            this.formData['listAdditional2'] = `${this.couponArt}, ${this.couponValue}`;
        } else {
            delete this.formData.listAdditional2;
        }

        // End Default data

        // Init customer
        if (this.currentBusinessTariffMultistep) {
            const customerKeys = [
                'legalForm',
                'company',
                'salutation',
                'title',
                'firstname',
                'lastname',
                'email',
                'phoneNumber',
                'dateOfBirth',
                'taxnumberident'
            ];

            const customerData = this.extractFormValues(customerKeys);

            // Business journey: send the phone number as "mobileNumber" (still a string, same value)
            if (customerData.phoneNumber !== undefined) {
                customerData.mobileNumber = customerData.phoneNumber;
                delete customerData.phoneNumber;
            }

            const businessBranch = $('[name="businessBranch"]').val();

            if (Object.keys(customerData).length > 0) {
                this.formData.customer = customerData;

                if (customerData.email) {
                    this.formData.customer.emailCommunication = {
                        channelAddress: customerData.email
                    };
                }

                if (customerData.legalForm === '3') {
                    delete this.formData.customer.faxCommunication;
                } else if (businessBranch) {
                    this.formData.customer.faxCommunication = {
                        channelAddress: businessBranch
                    };
                } else {
                    delete this.formData.customer.faxCommunication;
                }
            }
        } else {
            const customerKeys = ['legalForm', 'salutation', 'title', 'firstname', 'lastname', 'email', 'phoneNumber', 'dateOfBirth'];

            const customerData = this.extractFormValues(customerKeys);

            if (Object.keys(customerData).length > 0) {
                this.formData.customer = customerData;

                if (customerKeys.includes('legalForm')) {
                    customerData['legalForm'] = '1';
                }
            }
        }
        // End Init customer


        // Init delivery
        const deliveryKeys = ['city', 'housenumber', 'housenumberAddition', 'postalCode', 'street'];

        // Get all fields for each key in deliveryKeys
        const deliveryData = this.extractFormValues(deliveryKeys);

        if (Object.keys(deliveryData).length > 0) {
            this.formData.deliveryPointAddress = deliveryData;
        }
        // End Init delivery

        if(this.defaultSecretKey) {
            this.formData.listAdditional3 = this.defaultSecretKey;
        }
        if(this.defaultReferralContractNumber) {
            this.formData.stringAdditional3 = this.defaultReferralContractNumber;
        }

        // Init deviating customer
        const hasDifferentAddress = $(SELECTORS.DIFFERENT_ADDRESS_CHECKBOX).prop('checked');
        const hasDifferentInvoiceEmail = this.currentBusinessTariffMultistep && $(SELECTORS.DIFFERENT_INVOICE_EMAIL_CHECKBOX).is(':checked');
        const invoiceEmail = $(SELECTORS.INVOICE_EMAIL_INPUT).val();

        if (hasDifferentAddress || hasDifferentInvoiceEmail) {
            let deviatingCustomerData = {};

            if (hasDifferentAddress) {
                const deviatingCustomerKeys = this.currentBusinessTariffMultistep
                    ? ['legalForm', 'company', 'firstname', 'lastname']
                    : ['legalForm', 'salutation', 'title', 'firstname', 'lastname', 'email', 'phoneNumber', 'dateOfBirth'];

                // Use data from "Abweichende Rechnungsadresse"
                deviatingCustomerData = this.extractFormValues(deviatingCustomerKeys, 'd');

                const isDeviatingPerson = this.currentBusinessTariffMultistep && $(SELECTORS.D_LEGAL_FORM).val() === '4';

                if (this.currentBusinessTariffMultistep && !isDeviatingPerson) {
                    // dfirstname/dlastname may still hold stale values from when "Person" was selected,
                    // so discard them before falling back to the normal customer's name
                    delete deviatingCustomerData.firstname;
                    delete deviatingCustomerData.lastname;

                    const normalCustomerData = this.extractFormValues(['firstname', 'lastname']);

                    if (normalCustomerData.firstname) {
                        deviatingCustomerData.firstname = normalCustomerData.firstname;
                    }

                    if (normalCustomerData.lastname) {
                        deviatingCustomerData.lastname = normalCustomerData.lastname;
                    }
                }

                if (isDeviatingPerson) {
                    delete deviatingCustomerData.company;
                }

                // For private customer journey keep the old legalForm behavior
                if ((!this.currentBusinessTariffMultistep && Object.keys(deviatingCustomerData).length > 0) || isDeviatingPerson) {
                    deviatingCustomerData['legalForm'] = '1';
                }

                const deviatingDeliveryKeys = ['city', 'housenumber', 'housenumberAddition', 'postalCode', 'street'];
                const deviatingDeliveryData = this.extractFormValues(deviatingDeliveryKeys, 'd');

                if (Object.keys(deviatingDeliveryData).length > 0) {
                    this.formData.deviatingCustomerAddress = deviatingDeliveryData;
                } else {
                    delete this.formData.deviatingCustomerAddress;
                }
            } else if (hasDifferentInvoiceEmail) {
                // If only different invoice email is provided,
                // copy required customer data from normal customer.
                const normalCustomerKeys = this.currentBusinessTariffMultistep
                    ? ['legalForm', 'firstname', 'lastname']
                    : ['legalForm', 'salutation', 'title', 'firstname', 'lastname', 'phoneNumber', 'dateOfBirth'];

                deviatingCustomerData = this.extractFormValues(normalCustomerKeys);

                // For private customer journey keep the old legalForm behavior
                if (!this.currentBusinessTariffMultistep && Object.keys(deviatingCustomerData).length > 0) {
                    deviatingCustomerData['legalForm'] = '1';
                }

                const normalDeliveryKeys = ['city', 'housenumber', 'housenumberAddition', 'postalCode', 'street'];
                const normalDeliveryData = this.extractFormValues(normalDeliveryKeys);

                if (Object.keys(normalDeliveryData).length > 0) {
                    this.formData.deviatingCustomerAddress = normalDeliveryData;
                } else {
                    delete this.formData.deviatingCustomerAddress;
                }
            } else {
                delete this.formData.deviatingCustomerAddress;
            }

            if (hasDifferentInvoiceEmail && invoiceEmail) {
                deviatingCustomerData.emailCommunication = {
                    channelAddress: invoiceEmail
                };
            }

            if (Object.keys(deviatingCustomerData).length > 0) {
                this.formData.deviatingCustomer = deviatingCustomerData;
            } else {
                delete this.formData.deviatingCustomer;
            }
        } else {
            delete this.formData.deviatingCustomer;
            delete this.formData.deviatingCustomerAddress;
        }
        // End deviating customer

        // Information about delivery
        const deviceNumberKeys = ['deliveryPointMeteringDeviceNumber', 'marketLocation',];

        this.addKeysToFormData(deviceNumberKeys, this.formData);

        // End information about delivery

        // Old supplier cancellation state
        switch ($(SELECTORS.OLD_SUPPLIER_CANCELLATION_STATE_RADIO).val()) {
            case 'oldSupplierNotCanceled':
                const oldSupplierNotCanceledKeys = ['oldSupplier', 'oldSupplierCustomerNumber'];
                this.addKeysToFormData(oldSupplierNotCanceledKeys, this.formData);

                this.formData['oldSupplierCancellationState'] = 'oldSupplierNotCanceled';
                delete this.formData['supplierOldCancellationDate'];

                if ($(SELECTORS.OLD_SUPPLIER_NAME).select2('data')[0]) {
                    this.formData['oldSupplierName'] = $(SELECTORS.OLD_SUPPLIER_NAME).select2('data')[0].text;
                } else {
                    delete this.formData['oldSupplierName'];
                }

                break;

            case 'oldSupplierCanceled':
                const oldSupplierCanceledKeys = ['supplierOldCancellationDate'];

                this.formData['oldSupplier'] = "";
                delete this.formData['oldSupplierCustomerNumber'];
                delete this.formData['oldSupplierName'];

                this.formData['oldSupplierCancellationState'] = 'oldSupplierCanceled';
                this.addKeysToFormData(oldSupplierCanceledKeys, this.formData);

                break;

            default:
                break;
        }
        // End old supplier cancellation state

        // Supply begin date specified
        switch ($(SELECTORS.SUPPLY_BEGIN_DATE_SPECIFIED_RADIO).val()) {
            case 'true':
                const supplyBeginDateSpecifiedKeys = ['supplyBeginDate'];
                this.addKeysToFormData(supplyBeginDateSpecifiedKeys, this.formData);

                this.formData['supplyBeginDateSpecified'] = true;

                break;

            case 'false':

                delete this.formData['supplyBeginDate'];

                this.formData['supplyBeginDateSpecified'] = false;

                break;

            default:
                break;
        }
        delete this.formData['oldSupplierName']; //remove by task Task #49832
        // End supply begin date specified

        switch ($(SELECTORS.PAYMENT_TYPE_RADIO_CHECKED).val()) {
            case 'sepaLastschrift':
                const bankAccountSpecifiedKeys = ['bankAccountOwnerName', 'bankName'];
                this.addKeysToFormData(bankAccountSpecifiedKeys, this.formData);
                this.formData['bankAccountIban'] = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT).val().replace(/\s+/g, '');
                this.formData['booleanAdditional1'] = 'false';
                break;

            case 'rechnungskunden':
                this.formData['booleanAdditional1'] = 'true';
                delete this.formData['bankAccountOwnerName']
                delete this.formData['bankAccountIban']
                delete this.formData['bankName'];
                delete this.formData['bankAccountBic'];
                break;

            default:
                this.formData['booleanAdditional1'] = 'false';
                delete this.formData['bankAccountOwnerName']
                delete this.formData['bankAccountIban']
                delete this.formData['bankName'];
                delete this.formData['bankAccountBic'];
                break;
        }

        if ($(SELECTORS.APPROVE_EMAIL_NOTIFICATION).is(':checked')) {
            this.formData.booleanAdditional2 = true;
        } else {
            this.formData.booleanAdditional2 = false;
        }


        switch ($(SELECTORS.SUPPLY_CHANGE_CAUSE).val()) {
            case 'supplierChange':


                if ($(SELECTORS.OLD_SUPPLIER_CANCELLATION_STATE_RADIO).val() === 'oldSupplierCanceled') {
                    this.formData['supplyBeginDate'] = this.increaseDate($('[name="supplierOldCancellationDate"]').val());
                    this.formData['supplyBeginDateSpecified'] = true;
                } else {
                    this.formData['supplyBeginDateSpecified'] = false;
                }

                break;

            case 'move':
                this.formData['oldSupplier'] = "";
                delete this.formData['oldSupplierCancellationState'];
                delete this.formData['supplierOldCancellationDate'];
                this.formData['supplyBeginDateSpecified'] = true;

                break;

            default:
                break;
        }

        if($(SELECTORS.MARKET_LOCATION_INPUT).val()) {
            delete this.formData['oldSupplierCustomerNumber'];
        }

        // console.log(this.formData);
    }

    validateIBAN() {
        const iban = $(SELECTORS.BANK_ACCOUNT_IBAN_INPUT).val().trim();
        const bankNameVal = $(SELECTORS.BANK_NAME_INPUT).val();
        const errorNameBank = $(SELECTORS.ERROR_NAME_BANK);

        $(SELECTORS.CONTAINER_BANK_NAME).addClass('loading');

        var ibanValueWithoutSpaces = iban.replace(/\s+/g, '');

        const clearFields = () => {
            if ($(SELECTORS.BANK_NAME_INPUT).val()) {
                this.clearInput($(SELECTORS.BANK_NAME_INPUT));
            }
            $(SELECTORS.BANK_NAME_INPUT).attr('disabled', true);
            errorNameBank.removeClass('-show');
            swiperMultistep.updateAutoHeight();
        }

        if (!ibanValueWithoutSpaces) {
            clearFields();
            return;
        }

        const dataToSend = {
            bankIdentifier: ibanValueWithoutSpaces.slice(4, 12),
            action: 'check_bank_name',
            nonce: myajax.nonces.check_bank_name // CSRF protect
        };

        $.ajax({
            url: myajax.url,
            data: dataToSend,
            dataType: 'json',
            type: 'POST',
            success: (response) => {
                console.log(response);
                if (response.data.bank && response.data.bic) {
                    handleValidResponse(response.data);
                } else {
                    if(response.data.message.trim() === 'iban_not_found') {
                        $(SELECTORS.BANK_NAME_INPUT).val('').trigger('change');
                    }
                    handleError();
                }
            },
            error: (data) => {
                console.log('validateBankCode ajax error');
                handleError();
            }
        });

        const handleValidResponse = (data) => {
            $(SELECTORS.CONTAINER_BANK_NAME).removeClass('loading');
            console.log(data);
            if (data.bank && data.bic) {
                $(SELECTORS.BANK_NAME_INPUT).val(data.bank).trigger('change');
                $(SELECTORS.BANK_NAME_INPUT).attr('disabled', true);
                errorNameBank.removeClass('-show');
            } else {
                $(SELECTORS.BANK_NAME_INPUT).removeAttr('disabled');
                errorNameBank.addClass('-show');
            }
            swiperMultistep.updateAutoHeight();

            this.formData['bankName'] = data.bank || '';
            this.formData['bankAccountIban'] = ibanValueWithoutSpaces || '';
            this.formData['bankAccountBic'] = data.bic || '';

        };

        const handleError = () => {
            $(SELECTORS.CONTAINER_BANK_NAME).removeClass('loading');
            $(SELECTORS.BANK_NAME_INPUT).removeAttr('disabled');
            errorNameBank.addClass('-show');
            swiperMultistep.updateAutoHeight();

            this.formData['bankName'] = bankNameVal || '';
            this.formData['bankAccountIban'] = ibanValueWithoutSpaces || '';
            this.formData['bankAccountBic'] = '';
        };
    }

    updateOwnerName() {
        const bankAccountOwnerName = $(SELECTORS.BANK_ACCOUNT_OWNER_NAME).val();
        this.formData['bankAccountOwnerName'] = bankAccountOwnerName ? bankAccountOwnerName : '';
    }

    // Get Streets by Postal Code
    getStreetsByPostalCode(postalCode, city = false) {
        const url = `${this.proxyUrl}?type=getAreaInformation`; // Updated URL
        const requestData = {
            address: {
                postalCode: postalCode
            },
            section: 'Electricity',
            consumption: this.defaultConsumption || $(SELECTORS.CONSUMPTION_INPUT).val() || 2500
        };

        // Add city to the address object if it's provided
        if (city) {
            requestData.address.city = city;
        }

        return $.ajax({
            url: url,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestData),
            success: (response) => {
                // Assuming the response is an array of street names
                const streets = response.streets || [];
                // console.log('Streets:', streets);
                return streets;
            },
            error: (xhr, status, error) => {
                console.error('Failed to retrieve streets:', error);
                return [];
            }
        });
    }

    decodeHtmlEntities(str) {
        let txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }

    initializeSelect2(select, customOptions = {}) {
        const $select = $(select);
        const $this = this;

        $select.each(function () {
            const selectThis = $(this);
            $this.initializeSingleSelect2(selectThis, customOptions, $this).then(() => {
                $this.setupMultipleSelectHandlers(selectThis, customOptions);
            });
        });
    }

// Function to initialize Select2 for a single element, returning a promise
    initializeSingleSelect2($select, customOptions, apiService) {
        return new Promise((resolve) => {
            const defaultOptions = {
                placeholder: 'Straße wählen',
                language: {
                    noResults: function () {
                        return 'Diese Straße wurde nicht gefunden oder PLZ ist nicht ausgefüllt';
                    }
                },
                escapeMarkup: function (markup) {
                    return markup;
                }
            };

            if (customOptions.multiple) {
                defaultOptions['dropdownParent'] = $select.parent();
            }

            const select2Options = $.extend(true, {}, defaultOptions, customOptions);

            if (!$select.hasClass('select2-hidden-accessible')) {
                $select.select2(select2Options);
                resolve();
            } else {
                $select.select2('destroy').select2(select2Options);
                resolve();
            }
        });
    }

// Additional setup for multiple select configuration, extracted into a separate function
    setupMultipleSelectHandlers($select, customOptions) {

        if (customOptions.multiple) {
            const idAttr = $select.attr('id');
            const $containerField = $select.closest('.nf-field-container');
            const searchField = $containerField.find('.select2-search__field');
            const searchContainer = $containerField.find('.select2-selection--multiple');

            searchField.attr('autocomplete', 'autocomplete_off_' + idAttr);
            searchField.attr('aria-autocomplete', 'autocomplete_off_' + idAttr);

            searchField.prop('readonly', true);

            searchContainer.on('touchstart click', function () {
                $containerField.find('.select2-search__field').prop('readonly', false);
            });

            $select.on('select2:opening', function () {
                $containerField.find('.select2-search__field').prop('readonly', false);
            });

            $select.on('select2:open', function () {
                if ($select.val().length) {
                    let selectedItem = $select.select2('data')[0];
                    let selectedText = selectedItem ? apiService.decodeHtmlEntities(selectedItem.text) : '';

                    if ($select.attr('name') === 'oldSupplier') {
                        $select.find('option').remove();
                    }
                    $select.val(null).trigger('change');
                    $containerField.find('.select2-search__field').val(selectedText);
                    $select.parent().addClass('-loading');

                    // Trigger input to display selected text for editing
                    setTimeout(() => {
                        $containerField.find('.select2-search__field').trigger("input");
                        setTimeout(() => {
                            $select.parent().removeClass('-loading');
                        }, 1);
                    }, 1);
                }
            });

            $select.on('select2:select', function () {
                searchField.blur();
            });

            $select.on('select2:closing', function () {
                searchField.prop('readonly', true);
            });
        }
    }

    // Method to destroy select2
    destroySelect2(select) {
        const $select = $(select);

        if ($select.hasClass('select2-hidden-accessible')) {
            $select.select2('destroy');
            $select.empty(); // Clear all options
        }
    }

    // Method to update select2 data
    updateSelect2Data(postalCode, select, defaultValue = false, city = false) {
        // Per-selector request token so a slower, superseded request cannot overwrite
        // the street list populated by a newer postal-code/city selection for the same select.
        this._streetRequestTokens = this._streetRequestTokens || {};
        const requestToken = (this._streetRequestTokens[select] = (this._streetRequestTokens[select] || 0) + 1);

        return new Promise((resolve) => {
            const $select = $(select);
            $select.removeClass('-filled');
            $select.empty().trigger('change');
            const loadingOption = new Option('Wird geladen...', 1, true, true);
            $select.append(loadingOption).val(1).trigger('change');

            this.getStreetsByPostalCode(postalCode, city).then(streets => {
                if (this._streetRequestTokens[select] !== requestToken) {
                    resolve(0); // a newer request for this select has since started
                    return;
                }

                $select.empty().trigger('change');

                const streetList = streets.streets || [];
                const streetData = streetList.map(street => ({ id: street, text: street }));

                streetData.forEach(street => {
                    const newOption = new Option(street.text, street.id, false, false);
                    $select.append(newOption);
                });

                if (defaultValue) {
                    $select.val(defaultValue).trigger('change');
                } else {
                    const placeholderOption = new Option('Straße', '', false, false);
                    $select.val(null).trigger('change');
                }

                $select.addClass('-filled');
                resolve(streetList.length); // resolve after all operations complete
            }).catch(error => {
                if (this._streetRequestTokens[select] !== requestToken) {
                    resolve(0); // a newer request for this select has since started
                    return;
                }

                console.error('Failed to fetch streets:', error);
                $select.empty().trigger('change');
                const errorOption = new Option('Error loading streets', '', false, false);
                $select.append(errorOption).trigger('change');
                resolve(0); // resolve even if an error occurs
            });
        });
    }

    // Method to attach event listener to postal code field
    attachPostalCodeChangeListener(postalCodeSelector, select) {
        // Attach event listener to postal code field
        $(document).on('blur', postalCodeSelector, (event) => {
            const newPostalCode = $(event.target).val();
            this.defaultPostalCode = newPostalCode;

            // Update select2 with the new postal code
            this.updateSelect2Data(newPostalCode, select);
        });
    }

    // Method to watch differentAddress checkbox
    watchDifferentAddress(checkboxSelector, select, postalCodeSelector) {
        const $checkbox = $(checkboxSelector);
        $(SELECTORS.SEND_DATA_FORM).find('.collapsed-data .item.differentAddress').hide()
        $checkbox.on('change', (event) => {
            if ($checkbox.is(':checked')) {
                $(SELECTORS.SEND_DATA_FORM).find('.collapsed-data .item.differentAddress').show()
            } else {
                $(SELECTORS.SEND_DATA_FORM).find('.collapsed-data .item.differentAddress').hide();

                if (this.currentBusinessTariffMultistep) {
                    this.resetDeviatingAddressLocation();
                }
            }
        });

        // Trigger change event to set the initial state
        $checkbox.trigger('change');
    }

    // Business deviating-address "PLZ & Ort" combined field: reuses the same Post-CD dataset
    // (global `postalCodes`), Select2 config and parsing method as the existing Belieferungsort
    // combo (postalcode_ort / section_multi-step_form_preview.es6 initSelect2()). Reusable as-is
    // for the private journey later - activation is controlled entirely by the call site.
    initDeviatingAddressLocationField() {
        const $combinedSelects = $(SELECTORS.D_POSTAL_CODE_AND_ORT_SELECT);

        if ($combinedSelects.length === 0) {
            return; // markup missing
        }

        this.initializeSelect2(SELECTORS.D_STREET, { multiple: true, minimumResultsForSearch: 999, maximumSelectionLength: 1 });
        this.disableDeviatingDependentFields();

        // Init each combined-select instance (step 1 + step-4 overview) separately, with its own
        // $select captured in closure. Sharing one multi-element jQuery object across instances
        // here previously caused typing/selecting in one field to clear/misplace the other
        // (dropdownParent and ajax.transport's $select.empty() both need a single, own element).
        $combinedSelects.each((index, element) => {
            const $select = $(element);

            if ($select.hasClass('select2-hidden-accessible')) {
                return; // already initialized - avoid duplicate Select2 instances/handlers
            }

            $select.select2({
                placeholder: 'PLZ & Ort',
                dropdownParent: $select.parent(),
                multiple: true,
                maximumSelectionLength: 1,
                minimumInputLength: 3,
                language: {
                    inputTooShort: function () {
                        return 'Bitte gib mindestens 3 Zeichen ein';
                    },
                    noResults: function () {
                        return 'Keine Übereinstimmungen gefunden';
                    }
                },
                ajax: {
                    transport: (params, success, failure) => {
                        if (typeof postalCodes === 'undefined' || !Array.isArray(postalCodes) || postalCodes.length === 0) {
                            $select.empty();
                            failure();
                            return;
                        }

                        const searchTerm = (params.data.term || '').toLowerCase();

                        // If less than 3 characters, clear the select and do not perform the search
                        if (searchTerm.length < 3) {
                            $select.empty();
                            return;
                        }

                        const isNumeric = /^\d+$/.test(searchTerm);

                        let filteredData = postalCodes.filter((item) => {
                            const combinedText = `${item.code} ${item.city}`.toLowerCase();
                            return isNumeric ? item.code.startsWith(searchTerm) : combinedText.includes(searchTerm);
                        });

                        filteredData.sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));

                        const results = filteredData.map((item) => ({
                            id: JSON.stringify({ code: item.code, city: item.city }),
                            text: `${item.code} ${item.city}`
                        }));

                        success({ results });
                    }
                }
            });

            $select.on('select2:select', (event) => {
                const selectedData = event.params.data;

                try {
                    const valueObject = JSON.parse(selectedData.id);

                    if (valueObject.code && valueObject.city) {
                        this.applyDeviatingAddressLocation(valueObject.code, valueObject.city);
                    }
                } catch (err) {
                    console.error('Failed to parse the selected PLZ & Ort value.');
                }
            });

            $select.on('select2:unselect', () => {
                this.resetDeviatingAddressLocation();
            });
        });
    }

    // Mirrors the selected PLZ & Ort option into every combined-select instance (step 1 and the
    // step-4 "Deine Rechnungsadresse" overview share the same .d-postalcode-ort-select class but
    // have no `name`, so they aren't covered by the generic name-based select2:select sync).
    // Skips the instance that already shows this value (the one the user just selected in).
    syncDeviatingAddressLocationSelects(postalCode, city) {
        const value = JSON.stringify({ code: postalCode, city: city });
        const text = `${postalCode} ${city}`;

        $(SELECTORS.D_POSTAL_CODE_AND_ORT_SELECT).each((index, element) => {
            const $select = $(element);
            const currentValue = $select.val();
            const currentSelected = Array.isArray(currentValue) ? currentValue[0] : currentValue;

            if (currentSelected === value) {
                return;
            }

            $select.find('option').remove();
            $select.append(new Option(text, value, true, true)).trigger('change');
        });
    }

    // Writes the selected Post-CD postal code/city into the canonical dpostalCode/dcity fields
    // (kept in sync with any duplicate copy - e.g. the step-4 overview - via updateFieldValues()),
    // then looks up streets via the existing MBS getAreaInformation proxy.
    applyDeviatingAddressLocation(postalCode, city) {
        this.syncDeviatingAddressLocationSelects(postalCode, city);
        this.updateFieldValues('dpostalCode', postalCode);
        this.updateFieldValues('dcity', city);

        this.resetDeviatingDependentFields();

        const requestId = (this.deviatingAddressRequestId = (this.deviatingAddressRequestId || 0) + 1);

        this.updateSelect2Data(postalCode, SELECTORS.D_STREET, false, city).then((streetCount) => {
            if (requestId !== this.deviatingAddressRequestId) {
                return; // superseded by a newer PLZ & Ort selection or a checkbox uncheck
            }

            if (streetCount > 0) {
                this.enableDeviatingDependentFields();
            } else {
                this.disableDeviatingDependentFields();
            }
        });
    }

    resetDeviatingAddressLocation() {
        // Invalidate any in-flight street lookup so its response cannot re-enable stale fields.
        this.deviatingAddressRequestId = (this.deviatingAddressRequestId || 0) + 1;

        $(SELECTORS.D_POSTAL_CODE_AND_ORT_SELECT).val(null).trigger('change');
        this.updateFieldValues('dpostalCode', '');
        this.updateFieldValues('dcity', '');
        this.resetDeviatingDependentFields();
    }

    resetDeviatingDependentFields() {
        $(SELECTORS.D_STREET).empty().trigger('change');
        this.updateFieldValues('dhousenumber', '');
        this.updateFieldValues('dhousenumberAddition', '');
        this.disableDeviatingDependentFields();
    }

    // Actual disabled state (not just styling) so Straße/Hausnummer/Hausnummer Zusatz cannot
    // validate or block navigation while no valid street list is available yet - mirrors the
    // required-if-showed pattern already used for data-show-triggers containers.
    disableDeviatingDependentFields() {
        [SELECTORS.D_STREET, SELECTORS.D_HOUSE_NUMBER].forEach((selector) => {
            const $field = $(selector);

            if ($field.attr('required') !== undefined) {
                $field.data('deviating-required', true);
                $field.removeAttr('required');
            }

            $field.closest('.nf-field-container').addClass('required-if-showed');
        });

        $(SELECTORS.D_STREET).prop('disabled', true);
        $(SELECTORS.D_HOUSE_NUMBER).prop('disabled', true);
        $(SELECTORS.D_HOUSE_NUMBER_ADDITION).prop('disabled', true);
    }

    enableDeviatingDependentFields() {
        [SELECTORS.D_STREET, SELECTORS.D_HOUSE_NUMBER].forEach((selector) => {
            const $field = $(selector);

            if ($field.data('deviating-required')) {
                $field.attr('required', true);
                $field.removeData('deviating-required');
            }

            $field.closest('.nf-field-container').removeClass('required-if-showed');
        });

        $(SELECTORS.D_STREET).prop('disabled', false);
        $(SELECTORS.D_HOUSE_NUMBER).prop('disabled', false);
        $(SELECTORS.D_HOUSE_NUMBER_ADDITION).prop('disabled', false);
    }

    initializeSupplierSelect2(select, aiValue = '') {
        // Define custom options for supplier select
        const customOptions = {
            ajax: {
                url: myajax.url,
                method: 'POST',
                dataType: 'json',
                delay: this.debounceDelay,
                data: function (params) {
                    return {
                        action: 'get_suppliers',
                        nonce: myajax.nonces.get_suppliers,
                        query: params.term // The search term entered by the user
                    };
                },
                processResults: function (data) {
                    return {
                        results: data.data // Map the data to the format expected by Select2
                    };
                },
                cache: true
            },
            language: {
                noResults: function () {
                    return 'keine Ergebnisse gefunden';
                },
                searching: function () {
                    return 'Suchen...';
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length;
                    return `Bitte geben Sie noch ${remainingChars} oder mehr Zeichen ein`;
                }
            },
            maximumSelectionLength: 1,
            placeholder: 'Bisheriger Energieversorger',
            allowClear: true,
            multiple: true,
            minimumResultsForSearch: 999,
            minimumInputLength: 3 // Only start searching when the user has input 3 or more characters
        };

        // Initialize select2 with custom options for suppliers
        this.initializeSelect2(select, customOptions);

        if (!aiValue) {
            return Promise.resolve(false);
        }

        const $select = $(select);
        const query = aiValue;

        console.log('[initializeSupplierSelect2] 🔍 Searching supplier for:', query);

        return $.ajax({
            url: myajax.url,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'get_suppliers',
                nonce: myajax.nonces.get_suppliers,
                query
            }
        }).then((data) => {
            const suppliers = (data && data.success && Array.isArray(data.data)) ? data.data : [];
            console.log('[initializeSupplierSelect2] 📦 Suppliers returned:', suppliers);

            if (!suppliers.length) {
                console.warn('[initializeSupplierSelect2] ⚠️ No suppliers found for query:', query);
                return false;
            }

            let bestMatch = suppliers.length === 1? suppliers[0] : suppliers.find(s => s.text.toLowerCase() === query.toLowerCase());

            if (!bestMatch) {
                return false;
            }

            console.log('[initializeSupplierSelect2] bestMatch:', bestMatch);

            const option = new Option(bestMatch.text, bestMatch.id, true, true);
            $select.append(option).trigger('change');
            return true;
        }).catch((err) => {
            console.error('[initializeSupplierSelect2] ❌ Supplier load failed:', err);
            return false;
        });
    }


    findTariffFormSubmit(event) {
        if (this.loading === true) {
            return;
        }
        this.loading = true;
        this.showLoader();

        // Get the selected value from the select input
        let postalCodeAndOrt = $(SELECTORS.POSTAL_CODE_AND_ORT_SELECT).val();

        // Handle multiple selections (if it's an array, use the first value)
        if ($.isArray(postalCodeAndOrt)) {
            postalCodeAndOrt = postalCodeAndOrt[0];
        }

        // Parse the selected value as JSON to get postal code and city
        const selectedData = JSON.parse(postalCodeAndOrt);
        const postalCode = selectedData.code;
        const city = selectedData.city;

        const consumption = $(SELECTORS.CONSUMPTION_INPUT).val() || 2500;
        const street = ($(SELECTORS.STREET_INPUT_FAKE).val()) ? $(SELECTORS.STREET_INPUT_FAKE).val()[0] : '';
        const houseNumber = ($(SELECTORS.HOUSE_NUMBER_INPUT_FAKE).val()) ? $(SELECTORS.HOUSE_NUMBER_INPUT_FAKE).val() : '';
        const secretKey = ($(SELECTORS.SECRET_KEY_INPUT).val()) ? $(SELECTORS.SECRET_KEY_INPUT).val() : '';
        const referralContractNumber = ($(SELECTORS.REFERRAL_CONTRACT_NUMBER).val()) ? $(SELECTORS.REFERRAL_CONTRACT_NUMBER).val() : '';

        // Call getPriceInformation with the extracted data
        return this.getPriceInformation(city, postalCode, consumption, street, houseNumber)
            .then(priceInfo => ({
                priceInfo, city
            }))
            .then(({priceInfo, city}) => {
                // console.log('Price information:', priceInfo);
                this.renderPriceInformation(priceInfo, city, postalCode, street, houseNumber, consumption, secretKey, referralContractNumber)

            })
            .catch(error => {
                this.hideLoader();
                console.error('Error:', error);
                $(SELECTORS.PRICE_INFO_CONTAINER).html('<div class="error-wrapper"><h4 class="error-msg">Wir machen gerade ein Update, bitte versuche es später erneut.</h4></div>')
            });
    }

    sendCollectDate() {
        //event.preventDefault();
        //Get all info
        this.collectFormData();
        this.blacklistCheckPromise = null;

        if (String(this.formData.tarifId) === '125') {
            this.formData.enwgEnfgCustomerInfo = {
                enfgPrerequisite: "KUNDE_ERFUELLT_DIE_VORAUSSETZUNG",
                enfgReasonPrivilege: "ELEKTRISCH_ANGETRIEBENE_WAERMEPUMPEN",
                controlChannel: "AN_AUS",
                otherTechnicalDevices: "VORHANDEN",
                enwgModule: "MODULE_2",
                installationType: "WAERMEPUMPE",
                commissioningDateEnwg: "INBETRIEBSETZUNG_DER_TR_NACH_2023",
                additionalInfo: ""
            };
        } else {
            delete this.formData.enwgEnfgCustomerInfo;
        }

        //Get Credit Score (business tariff -> SCHUFA Business flow, otherwise the existing personal flow)
        let schufaRequest;

        if (this.currentBusinessTariffMultistep) {
            schufaRequest = this.startBusinessCreditScoreCheck();
        } else if (String(this.formData.tarifId) === '124') {
            // Tariff ID 124: private customers are disconnected from the SCHUFA check.
            // No credit-score request is sent and finishAcquisition always carries
            // riskClass = "R5". Every other tariff ID keeps the real SCHUFA-derived class.
            delete this.formData['integerAdditional1'];
            this.formData['riskClass'] = 'R5';
            schufaRequest = $.Deferred().resolve().promise();
        } else {
            schufaRequest = this.getCreditScore(this.generatePersonData());
        }

        schufaRequest
            .always(async () => {
                let $this = this.formData;
                let Api = this;
                // Send collected data to the specified URL
                if(!Api.wasSendToApi) {
                    Api.wasSendToApi = true;

                    // Blacklist check runs after the SCHUFA-derived riskClass has
                    // already been assigned above and immediately before
                    // finishAcquisition. checkCustomerBlacklist() is documented to
                    // always resolve (never reject, always settle within a finite
                    // time), but this try/catch is a deliberate second layer: no
                    // error from the blacklist stage may ever prevent or delay
                    // finishAcquisition below, which must always run.
                    //
                    // Only the regular (private) multistep is blacklist-checked.
                    // The business multistep form (currentBusinessTariffMultistep)
                    // has its own SCHUFA Business risk flow and the check itself is
                    // never started for it.
                    let blacklistResult = {matched: false};

                    if (!Api.currentBusinessTariffMultistep) {
                        try {
                            blacklistResult = await Api.checkCustomerBlacklist({
                                lastName: Api.formData?.customer?.lastname,
                                street: Api.formData?.deliveryPointAddress?.street,
                                postalCode: Api.formData?.deliveryPointAddress?.postalCode,
                                houseNumber: Api.formData?.deliveryPointAddress?.housenumber
                            });
                        } catch (error) {
                            try {
                                Api.reportBlacklistCheckError({
                                    event: 'customer_check_js_exception',
                                    stage: 'before_finish_acquisition',
                                    message: error instanceof Error ? error.message : String(error)
                                });
                            } catch (reportError) {
                                console.warn('Blacklist error reporting failed:', reportError);
                            }

                            blacklistResult = {matched: false};
                        }
                    }

                    // A no-match or any technical failure both preserve the
                    // SCHUFA-derived riskClass already set above - never reset it.
                    if (blacklistResult?.matched === true) {
                        Api.formData['riskClass'] = 'R6';
                    }

                    $.ajax({
                        url: `${this.proxyUrl}?type=finishAcquisition`,
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(this.formData),
                        headers: {
                            'Authorization': this.authorizationHeader
                        },
                        success: async (response) => {

                            await sendTag('zahlungspflichtig_bestellen', 'google');
                            await sendTag('zahlungspflichtig_bestellen', 'matomo');

                            let businessPartnerNumber = '';
                            let contractNumber = '';

                            if (typeof response === 'number' || (typeof response === 'string' && /^\d+$/.test(response))) {
                                // API returned just the BusinessPartnerNumber
                                businessPartnerNumber = String(response);
                            } else if (response && typeof response === 'object') {
                                businessPartnerNumber = response.businessPartnerNumber ? String(response.businessPartnerNumber) : '';
                                contractNumber = response.contractNumber ? String(response.contractNumber) : '';
                            }

                            // Prepare tariff id if present, otherwise fallback
                            const tariffIdForDl = (Api.formData && Api.formData.tarifId) ? String(Api.formData.tarifId) : 'Vertrag';

                            // ---- NEW: stash purchase payload for the thank-you page (enhanced_conversion stays as-is)
                            await sendTagGoogleSubmit(
                                Api.formData.customer.email,
                                Api.formData.customer.phoneNumber || Api.formData.customer.mobileNumber,
                                {
                                    businessPartnerNumber: businessPartnerNumber,
                                    contractNumber: contractNumber,
                                    tariffId: tariffIdForDl,
                                    value: 0.00,
                                    currency: 'EUR'
                                }
                            );

                            await $.ajax({
                                url: myajax.url,
                                type: 'GET',
                                dataType: 'json',
                                data: { action: 'update_last_finish_acquisition' }
                            }).catch((e) => {
                                console.warn('update_last_finish_acquisition failed', e);
                            });

                            try {
                                const sendResult = await Api.sendBusinessPartnerNumberAsPromise({
                                    businessNumber: response.businessPartnerNumber || response,
                                    isAgreement: Api.formData.booleanAdditional2,
                                });
                            } catch (error) {
                                console.error('Business partner flow error:', error);
                            } finally {
                                const successPath = Api.currentBusinessTariffMultistep
                                    ? '/business/auftrag-versendet'
                                    : '/auftrag-versendet';
                                window.location.href = `${successPath}?email=${Api.formData.customer.email}&firstname=${Api.formData.customer.firstname}`;
                            }
                        },
                        error: function (xhr, status, error) {
                            console.error('Error sending data:', error);
                            $('.api-error-message').html('Leider ist etwas schiefgelaufen. Bitte versuche es erneut.');
                            swiperMultistep.updateAutoHeight();
                            Api.wasSendToApi = false;

                            const html = xhr.responseText.trim();
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            let parsedBody = doc.body.innerHTML.trim();

                            if (parsedBody && parsedBody.length > 0 && parsedBody !== html) {
                                Api.sendToEmailResponse(parsedBody, false);
                            } else {
                                Api.sendToEmailResponse(html, false);
                            }
                        }
                    });
                }
            });
    }

    sendBusinessPartnerNumberAsPromise(requestData) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${this.proxyUrl}?type=sendBusinessPartnerNumber`,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(requestData),
                headers: {
                    'Authorization': this.authorizationHeader
                },
                success(response) {
                    resolve(response);
                },
                error(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX error: ' + textStatus + ' - ' + errorThrown);
                    reject(new Error('AJAX error: ' + textStatus + ' - ' + errorThrown));
                }
            });
        });
    }

    renderCollectInfo(wrapper) {
        const dashIfEmpty = ['deliveryPointMeteringDeviceNumber', 'marketLocation'];

        $(wrapper).find('[data-name]').each((index, element) => {
            const dataName = $(element).data('name');

            this.collectFormData();

            // Extract value from nested structure
            let value = this.getNestedValue(this.formData, dataName);

            // Put "-" for specific fields when empty
            if (dashIfEmpty.includes(dataName) && (value === undefined || value === '')) {
                value = '-';
            }

            const salutationValues = {
                '2': 'Herr',
                '1': 'Frau',
                '3': 'Familie',
                '5': 'Divers'
            };

            const legalFormValues = {
                '2': 'Firma',
                '3': 'Verein',
                '4': 'Person'
            };

            if (value !== undefined && (value !== '' || (value === '' && (dataName !== 'customer.salutation' || dataName !== 'deviatingCustomer.salutation')))) {
                switch (dataName) {
                    case 'customer.salutation':
                    case 'deviatingCustomer.salutation':
                        $(element).html(`<b>${salutationValues[value] || value}</b>`);
                        break;

                    case 'customer.legalForm':
                    case 'deviatingCustomer.legalForm':
                        $(element).html(`<b>${legalFormValues[String(value)] || value}</b>`);
                        break;

                    case 'customer.dateOfBirth':
                    case 'supplierOldCancellationDate':
                        $(element).html(`<b>${this.convertDate(value)}</b>`);
                        break;
                    case 'supplyBeginDate':
                        if (
                            this.formData['supplyChangeCause'] === 'supplierChange' &&
                            $(SELECTORS.OLD_SUPPLIER_CANCELLATION_STATE_RADIO).val() === 'oldSupplierCanceled'
                        ) {
                            this.formData['supplyBeginDate'] = this.increaseDate($('[name="supplierOldCancellationDate"]').val());
                            $(element).html(`<b>${this.convertDate(this.formData['supplyBeginDate'])}</b>`);
                        } else {
                            $(element).html(`<b>${this.convertDate(value)}</b>`);
                        }
                        break;
                    case 'oldSupplierName':
                        if (this.formData['oldSupplierCancellationState'] === 'oldSupplierNotCanceled' && $(SELECTORS.OLD_SUPPLIER_NAME).select2('data').length > 0) {
                            let oName = $(SELECTORS.OLD_SUPPLIER_NAME).select2('data')[0].text;
                            $(element).html(`<b>${oName}</b>`);
                        } else {
                            $(element).html('');
                        }
                        break;
                    default:
                        $(element).html(`<b>${value}</b>`);
                        break;
                }
            } else {
                switch (dataName) {
                    case 'oldSupplierName':

                        if (this.formData['oldSupplierCancellationState'] === 'oldSupplierNotCanceled' && $(SELECTORS.OLD_SUPPLIER_NAME).select2('data').length > 0) {
                            let oName = $(SELECTORS.OLD_SUPPLIER_NAME).select2('data')[0].text;
                            $(element).html(`<b>${oName}</b>`);
                        } else {
                            $(element).html('');
                        }
                        break;
                    default:
                        if (dashIfEmpty.includes(dataName)) {
                            $(element).html('<b>-</b>');
                        } else {
                            $(element).html('');
                        }
                        break;
                }

            }
        });
        $(wrapper).find('[data-input-name]').each((index, element) => {
            const dataName = $(element).data('input-name');

            const inputValue = $(`input[name="${dataName}"]`).val();

            if(inputValue) {
                $(element).html(`<b>${inputValue}</b>`);
            }
        });
    }

    getNestedValue(obj, keyString) {
        const keys = keyString.split('.');
        let value = obj;

        for (let key of keys) {
            if (value && value.hasOwnProperty(key)) {
                value = value[key];
            } else {
                return undefined;
            }
        }

        return value;
    }

    clearErrorMsg() {
        $(SELECTORS.PRICE_INFO_CONTAINER).html('')
        $(SELECTORS.PRICE_INFO_CONTAINER_WRAPPER).hide();
        $(SELECTORS.RESULT_TARIFF).hide();
    }
    sendToEmailResponse(error, isSchufa) {
        try {
            const dataToSend = {
                formData: JSON.stringify(this.formData),
                error: error,
                action: 'send_error_to_email',
                schufa: isSchufa,
                // Keep the same SCHUFA recipients, but identify Business SCHUFA
                // explicitly in the email subject and body.
                schufa_type: isSchufa && this.currentBusinessTariffMultistep ? 'business' : 'personal'
            };

            // console.log(dataToSend);

            return $.ajax({
                url: myajax.url, // Replace with your actual email sending URL
                method: 'POST',
                data: dataToSend,
                success: (response) => {
                    // console.log(response);
                },
                error: (xhr, status, error) => {
                    console.error(error);
                }
            });
        } catch (emailError) {
            // Error reporting itself must not interrupt the acquisition flow.
            console.error('Failed to start error email request:', emailError);
            return $.Deferred().reject(emailError).promise();
        }
    }

    getCreditScore (personData) {
        // Obtain the authentication token and make a POST request to the proxy URL
        return $.ajax({
            url: `${this.proxyUrl}?type=getCreditScore`, // Proxy URL
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(personData),
            success: (response) => {
                // Parse the response if it's not already an object
                const creditScoreData = JSON.parse(response);

                // Log and handle the credit score details
                // console.log('Credit score retrieved:', creditScoreData);
                if (this.formData) {
                    if(creditScoreData["infoText"] === "25 DIE ANGEFRAGTE PERSON WURDE UNS ALS VERSTORBEN GEMELDET") {
                        this.formData['integerAdditional1'] = "100";
                        this.formData['riskClass'] = ratingMapping['DEAD'];
                    } else {
                        this.formData['integerAdditional1'] = creditScoreData.value;

                        const rangeFromApi = creditScoreData.range;
                        this.formData['riskClass'] = ratingMapping[rangeFromApi] ? ratingMapping[rangeFromApi] : rangeFromApi;
                    }

                    const isValueEmpty = !creditScoreData.value || $.trim(creditScoreData.value) === "" || creditScoreData.value === 'null';
                    const isRangeEmpty = !creditScoreData.range || $.trim(creditScoreData.range) === "" || creditScoreData.range === 'null';

                    if (isValueEmpty && isRangeEmpty) {
                        this.sendToEmailResponse(response, true);
                    }
                }

            },
            error: (xhr, status, error) => {
                // Handle error
                const fullErrorResponse = xhr.responseText; // Get the full response text

                if (this.formData) {
                    delete this.formData['integerAdditional1'];
                    delete this.formData['riskClass'];
                }

                try {
                    // Parse the full error response into an object
                    const parsedError = JSON.parse(fullErrorResponse);

                    // console.log('Parsed Error as Array:', parsedError);

                    const errorStatus = $.trim(parsedError.status);

                    // console.log(errorStatus);

                    if(!errorStatus || (errorStatus && errorStatus != 404)) {
                        this.sendToEmailResponse(fullErrorResponse, true);
                    }

                    if(errorStatus && errorStatus == 404) {
                        this.formData['integerAdditional1'] = '9999';
                        this.formData['riskClass'] = ratingMapping['404'];
                    }

                } catch (parseError) {
                    console.error('Error parsing response:', parseError);
                    console.error('Original response text:', fullErrorResponse);
                }
            }
        });
    }

    // Wrap SCHUFA Business startup so even an unexpected synchronous frontend
    // error becomes a rejected promise handled by sendCollectDate().always().
    startBusinessCreditScoreCheck() {
        try {
            const request = this.getBusinessCreditScore(this.generateBusinessSchufaData());

            if (!request || typeof request.always !== 'function') {
                throw new Error('SCHUFA Business did not return a jQuery promise.');
            }

            return request;
        } catch (error) {
            // A synchronous frontend error must be reported, but must never block
            // the existing finishAcquisition flow in sendCollectDate().
            if (this.formData) {
                delete this.formData['integerAdditional1'];
                delete this.formData['riskClass'];
            }

            this.sendToEmailResponse(JSON.stringify({
                step: 'startBusinessCreditScoreCheck',
                error: error && error.message ? error.message : String(error)
            }), true);

            return $.Deferred().reject(error).promise();
        }
    }

    // Build the dynamic payload SCHUFA Business needs from the already-collected formData.
    // Returns null when a required value is missing so the caller can treat it as a technical error.
    generateBusinessSchufaData() {
        const companyName = $.trim((this.formData.customer && this.formData.customer.company) || '');

        const hasDifferentAddress = $(SELECTORS.DIFFERENT_ADDRESS_CHECKBOX).prop('checked');

        // A different invoice email alone must not be treated as a genuinely different address.
        const address = (hasDifferentAddress && this.formData.deviatingCustomerAddress)
            ? this.formData.deviatingCustomerAddress
            : this.formData.deliveryPointAddress;

        const street = (address && address.street) || '';
        const housenumber = (address && address.housenumber) || '';
        const housenumberAddition = (address && address.housenumberAddition) || '';
        const postalCode = (address && address.postalCode) || '';
        const city = (address && address.city) || '';

        const streetWithNumber = [street, housenumber, housenumberAddition]
            .map(part => $.trim(part || ''))
            .filter(Boolean)
            .join(' ');

        if (!companyName || !streetWithNumber || !postalCode || !city) {
            return null;
        }

        return {
            companyName,
            address: {
                streetWithNumber,
                postalCode,
                city
            }
        };
    }

    // Applies a validated SCHUFA Business proxy response to formData.
    applyBusinessCreditScoreResponse(response) {
        let normalized = response;

        if (typeof normalized === 'string') {
            try {
                normalized = JSON.parse(normalized);
            } catch (e) {
                normalized = null;
            }
        }

        if (!normalized || typeof normalized !== 'object') {
            delete this.formData['integerAdditional1'];
            delete this.formData['riskClass'];
            this.sendToEmailResponse(typeof response === 'string' ? response : JSON.stringify(response), true);
            return;
        }

        if (normalized.matched === true) {
            const value = normalized.value;
            const riskClass = normalized.riskClass;
            const isValueValid = typeof value === 'number' && !isNaN(value);
            const isRiskClassValid = riskClass === 'R1' || riskClass === 'R5';

            if (!isValueValid || !isRiskClassValid) {
                delete this.formData['integerAdditional1'];
                delete this.formData['riskClass'];
                this.sendToEmailResponse(JSON.stringify(normalized), true);
                return;
            }

            this.formData['integerAdditional1'] = value;
            this.formData['riskClass'] = riskClass;
        } else if (normalized.matched === false) {
            if (normalized.riskClass !== 'R1') {
                delete this.formData['integerAdditional1'];
                delete this.formData['riskClass'];
                this.sendToEmailResponse(JSON.stringify(normalized), true);
                return;
            }

            delete this.formData['integerAdditional1'];
            this.formData['riskClass'] = 'R1';
        } else {
            delete this.formData['integerAdditional1'];
            delete this.formData['riskClass'];
            this.sendToEmailResponse(JSON.stringify(normalized), true);
        }
    }

    getBusinessCreditScore(businessData) {
        // Clear potentially stale values from a previous attempt before starting the request.
        delete this.formData.integerAdditional1;
        delete this.formData.riskClass;

        if (!businessData) {
            console.error('SCHUFA Business: missing companyName/streetWithNumber/postalCode/city, request not sent.');
            this.sendToEmailResponse('SCHUFA Business: missing required companyName/streetWithNumber/postalCode/city before starting the request.', true);
            return $.Deferred().reject().promise();
        }

        return $.ajax({
            url: `${this.proxyUrl}?type=getBusinessCreditScore`,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(businessData),
            success: (response) => {
                try {
                    this.applyBusinessCreditScoreResponse(response);
                } catch (processingError) {
                    delete this.formData['integerAdditional1'];
                    delete this.formData['riskClass'];
                    this.sendToEmailResponse(JSON.stringify({
                        step: 'applyBusinessCreditScoreResponse',
                        error: processingError && processingError.message
                            ? processingError.message
                            : String(processingError)
                    }), true);
                }
            },
            error: (xhr, status, error) => {
                delete this.formData['integerAdditional1'];
                delete this.formData['riskClass'];
                this.sendToEmailResponse(xhr.responseText || error, true);
            }
        });
    }

    /**
     * Reports a blacklist-check failure that only exists in the browser (timeout,
     * network error, malformed response, missing localized config, JS exception)
     * to the Blacklist MU-plugin Logs table. Strictly fire-and-forget: never
     * awaited by callers, never throws, never retries, and carries no customer
     * matching fields - only an allowlisted event name plus safe metadata.
     *
     * Skipped when the server already confirmed it logged the same failure
     * itself (details.alreadyLogged), so one failure does not produce two log
     * rows.
     *
     * @param {{event: string, stage?: string, message?: string, status?: (string|number), textStatus?: string, alreadyLogged?: boolean}} details
     */
    reportBlacklistCheckError(details) {
        try {
            if (details?.alreadyLogged === true) {
                return;
            }

            if (typeof myajax === 'undefined' || !myajax?.url || !myajax?.nonces?.check_customer_blacklist) {
                console.warn('Blacklist error report skipped, myajax config missing:', details);
                return;
            }

            $.ajax({
                url: myajax.url,
                type: 'POST',
                dataType: 'json',
                timeout: 5000,
                data: {
                    action: 'gruuun_blacklist_report_customer_check_error',
                    nonce: myajax.nonces.check_customer_blacklist,
                    event: String(details?.event ?? 'customer_check_js_exception'),
                    stage: String(details?.stage ?? ''),
                    message: String(details?.message ?? '').slice(0, 500),
                    status: details?.status ?? '',
                    textStatus: String(details?.textStatus ?? '')
                }
            }).catch((e) => {
                // Best-effort only - never retried, never surfaced further.
                console.warn('Blacklist error report failed to send:', e);
            });
        } catch (e) {
            console.warn('Blacklist error report threw synchronously:', e);
        }
    }

    /**
     * Checks the customer against the imported blacklist (grüüün Blacklist MU
     * plugin) via WordPress AJAX.
     *
     * Contract: always resolves to {matched: boolean}, never rejects, and
     * always settles within a finite time (AJAX timeout + a Promise-level
     * safety net). Any technical failure - missing localized config, a
     * synchronous exception, an HTTP/JSON error, a timeout, or a response that
     * does not strictly match the documented shape - resolves {matched: false}
     * so the SCHUFA-derived riskClass is preserved and finishAcquisition is
     * never blocked or delayed. Such failures are reported to the Blacklist
     * MU-plugin Logs via reportBlacklistCheckError() (fire-and-forget).
     *
     * Caches the settled/in-flight promise so a single acquisition attempt never
     * fires more than one blacklist request; sendCollectDate() clears the cache
     * at the start of each new attempt. Because the promise only ever resolves
     * once, a late AJAX callback arriving after the timeout safety net already
     * resolved it is a no-op - it cannot override riskClass or re-trigger
     * finishAcquisition.
     *
     * @param {{lastName: *, street: *, postalCode: *, houseNumber: *}} customerData
     * @return {Promise<{matched: boolean}>}
     */
    checkCustomerBlacklist(customerData) {
        if (this.blacklistCheckPromise) {
            return this.blacklistCheckPromise;
        }

        const AJAX_TIMEOUT_MS = 8000;
        const SAFETY_NET_TIMEOUT_MS = 8500;

        const executor = (resolve) => {
            let settled = false;
            const settle = (result) => {
                if (settled) {
                    return;
                }
                settled = true;
                resolve(result);
            };

            // Promise-level safety net: guarantees a finite settle time even if
            // jQuery's own `timeout` option fails to fire the error callback.
            setTimeout(() => {
                if (settled) {
                    return;
                }
                this.reportBlacklistCheckError({event: 'customer_check_timeout', stage: 'promise_safety_net'});
                settle({matched: false});
            }, SAFETY_NET_TIMEOUT_MS);

            if (typeof myajax === 'undefined' || !myajax?.url) {
                this.reportBlacklistCheckError({event: 'customer_check_config_missing', stage: 'myajax_url'});
                settle({matched: false});
                return;
            }

            if (!myajax?.nonces?.check_customer_blacklist) {
                this.reportBlacklistCheckError({event: 'customer_check_config_missing', stage: 'myajax_nonce'});
                settle({matched: false});
                return;
            }

            const lastName = String(customerData?.lastName ?? '');
            const street = String(customerData?.street ?? '');
            const postalCode = String(customerData?.postalCode ?? '');
            const houseNumber = String(customerData?.houseNumber ?? '');

            try {
                $.ajax({
                    url: myajax.url,
                    type: 'POST',
                    dataType: 'json',
                    timeout: AJAX_TIMEOUT_MS,
                    data: {
                        action: 'gruuun_blacklist_check_customer',
                        nonce: myajax.nonces.check_customer_blacklist,
                        lastName,
                        street,
                        postalCode,
                        houseNumber
                    },
                    success: (response) => {
                        const matched = response?.data?.matched;

                        if (response?.success !== true || typeof matched !== 'boolean') {
                            this.reportBlacklistCheckError({
                                event: 'customer_check_invalid_response',
                                stage: 'success_callback'
                            });
                            settle({matched: false});
                            return;
                        }

                        settle({matched});
                    },
                    error: (xhr, status, error) => {
                        const alreadyLogged = xhr?.responseJSON?.data?.logged === true;
                        const event = status === 'timeout' ? 'customer_check_timeout'
                            : status === 'parsererror' ? 'customer_check_parser_error'
                                : 'customer_check_ajax_error';

                        this.reportBlacklistCheckError({
                            event,
                            stage: 'error_callback',
                            status: xhr?.status ?? '',
                            textStatus: status,
                            message: String(error ?? ''),
                            alreadyLogged
                        });

                        settle({matched: false});
                    }
                });
            } catch (e) {
                this.reportBlacklistCheckError({
                    event: 'customer_check_js_exception',
                    stage: 'ajax_call',
                    message: e instanceof Error ? e.message : String(e)
                });
                settle({matched: false});
            }
        };

        this.blacklistCheckPromise = new Promise((resolve) => {
            try {
                executor(resolve);
            } catch (e) {
                this.reportBlacklistCheckError({
                    event: 'customer_check_js_exception',
                    stage: 'executor',
                    message: e instanceof Error ? e.message : String(e)
                });
                resolve({matched: false});
            }
        }).catch((e) => {
            // Final safety net: checkCustomerBlacklist() must never reject.
            console.warn('Blacklist check promise rejected unexpectedly:', e);
            return {matched: false};
        });

        return this.blacklistCheckPromise;
    }

    generatePersonData() {
        // Mapping salutation codes to gender values
        const salutationValues = {
            '5': 'DIVERSE',
            '1': 'FEMALE',
            '2': 'MALE',
            '3': 'UNKNOWN'
        };

        // Extract form values once and store them in variables
        const formValues = this.extractFormValues([
            'firstname', 'lastname', 'salutation', 'dateOfBirth',
            'street', 'housenumber', 'housenumberAddition', 'postalCode', 'city', 'supplyChangeCause', 'moveStreet',
            'moveHousenumber', 'moveHousenumberAddition', 'movePostalCode', 'moveCity'
        ]);

        const firstName = this.translateToGermanLetters(formValues['firstname'], 44);
        const lastName = this.translateToGermanLetters(formValues['lastname'], 46);
        const gender = salutationValues[formValues['salutation']] || 'UNKNOWN';
        const dateOfBirth = formValues['dateOfBirth'];
        const streetWithNumberVal = [
            formValues['street'],
            formValues['housenumber'],
            formValues['housenumberAddition'] || ''
        ].filter(Boolean).join(' ');

        const streetWithNumberValOld = [
            formValues['moveStreet'],
            formValues['moveHousenumber'],
            formValues['moveHousenumberAddition'] || ''
        ].filter(Boolean).join(' ');

        // Construct the current address object
        const currentAddress = {
            streetWithNumber: this.translateToGermanLetters(streetWithNumberVal, 46),
            postalCode: formValues['postalCode'],
            city: this.translateToGermanLetters(formValues['city'], 44),
            country: 'DEU'
        };

        // Construct the previous address object
        const previousAddress = {
            streetWithNumber: this.translateToGermanLetters(streetWithNumberValOld, 46),
            postalCode: formValues['movePostalCode'],
            city: this.translateToGermanLetters(formValues['moveCity'], 44),
            country: 'DEU'
        };

        // Construct the person data object
        if(this.defaultSupplyChangeCause === 'move') {
            return {
                personData: {
                    firstName,
                    lastName,
                    gender,
                    dateOfBirth,
                    addresses: {
                        currentAddress,
                        previousAddress
                    }
                }
            };
        } else {
            return {
                personData: {
                    firstName,
                    lastName,
                    gender,
                    dateOfBirth,
                    addresses: {
                        currentAddress
                    }
                }
            };
        }

    }
}

// init API service
export const apiService = new ApiService();

(function ($) {


    // function with redirect from another form
    function FakeFindTariff(response, markAsPrivateCustomer) {
        const consumption = $('.fake-find-tariff input[name="consumption"]').val();

        let postalCodeAndOrt = $('.fake-find-tariff select[name="postalcode_ort"]').val();

        if ($.isArray(postalCodeAndOrt)) {
            postalCodeAndOrt = postalCodeAndOrt[0];
        }

        if (!postalCodeAndOrt) {
            return;
        }

        const selectedData = JSON.parse(postalCodeAndOrt);
        const postalCode = selectedData.code;
        const city = selectedData.city;

        const tariffMultistepUrl = getTariffMultistepUrlFromNinjaResponse(response);

        apiService.sendDataAndRedirect(postalCode, city, consumption, tariffMultistepUrl, markAsPrivateCustomer === true);
    }

    $(document).on('nfFormSubmitResponse', function (event, response, id) {
        var rr = response && response.response;
        var settings = rr && rr.data && rr.data.settings;
        var wrapperClass = (settings && settings.wrapper_class) || '';
        var wrapperClasses = wrapperClass.split(/\s+/).filter(Boolean);

        var isFakeWidget = wrapperClasses.indexOf('fake-find-tariff') !== -1;
        var isRealWidget = !isFakeWidget && wrapperClasses.indexOf('find-tariff') !== -1;

        if (!isFakeWidget && !isRealWidget) {
            return;
        }

        if (isRealWidget) {
            event.preventDefault();
        }

        // Threshold decision happens only after Ninja Forms' own field validation has already
        // passed (this handler only runs on a successful nfFormSubmitResponse) and before any
        // redirect/API call - satisfies "after validation, before calculation" from the task.
        var widgetSelector = isFakeWidget ? '.fake-find-tariff' : '.find-tariff';
        var $consumptionInput = $(widgetSelector + ' input[name="consumption"]');
        var consumption = $consumptionInput.val();

        // "Is this a business page" is resolved via AJAX (URL prefix vs. ACF Options
        // "Business homepage"), cached once per page load - see the constructor.
        apiService.isBusinessPageByUrlPromise.then(function (isBusinessPageByUrl) {
            // Original, unchanged flow for this widget - only reached once the consumption
            // threshold decision (below) resolves to "proceed". markAsPrivateCustomer is only
            // ever true when called from popup1's "Ich bin Privatkunde" click below.
            function proceedWithOriginalFlow(markAsPrivateCustomer) {
                sendTag('TarifWahlen1', 'google');
                sendTag('TarifWahlen1', 'matomo');

                if (isFakeWidget) {
                    setTimeout(function () {
                        FakeFindTariff(response, markAsPrivateCustomer === true);
                    }, 1);
                    return;
                }

                var tariffMultistepUrl = getTariffMultistepUrlFromNinjaResponse(response);

                apiService.setTariffFormUrl(tariffMultistepUrl);

                setTimeout(function () {
                    apiService.findTariffFormSubmit();
                }, 1);
            }

            // Business pages always calculate directly, regardless of consumption - the
            // threshold-popup flow below is Privatkunden-only.
            if (isBusinessPageByUrl) {
                proceedWithOriginalFlow();
                return;
            }

            var decision = apiService.evaluateConsumptionThreshold(consumption);

            // Real find-tariff form only: honor the isPrivateCustomer handoff marker from the
            // fake widget's redirect to skip the repeated popup1 exactly once. Never downgrades
            // 'popup2' - that confirmation must show every time consumption exceeds
            // CONSUMPTION_THRESHOLD_POPUP_2, marker or not. Never downgrades 'reject' either -
            // consumption validation still applies regardless of the marker.
            if (isRealWidget && decision === 'popup1' && apiService.hasIncomingPrivateCustomerMarker()) {
                decision = 'proceed';
            }

            if (decision === 'reject') {
                apiService.showConsumptionLimitError($consumptionInput);
                return;
            }

            if (decision === 'proceed') {
                proceedWithOriginalFlow();
                return;
            }

            var location = apiService.readWidgetLocation(widgetSelector);

            function continueToBusinessProduktauswahl() {
                apiService.sendDataAndRedirect(location.postalCode, location.city, consumption, apiService.getBusinessProduktauswahlUrl());
            }

            if (decision === 'popup1') {
                apiService.showConsumptionPopup1(function () {
                    proceedWithOriginalFlow(true);
                }, continueToBusinessProduktauswahl);
            } else if (decision === 'popup2') {
                apiService.showConsumptionPopup2(continueToBusinessProduktauswahl);
            }
        });
    });

    if ($(SELECTORS.SEND_DATA_FORM).length > 0) {
        apiService.initDefaultFieldStepForm2();

    }

    // $(SELECTORS.SEND_DATA_FORM).on('submit', apiService.sendCollectDate);

    //REMOVER AFTER COMPLETE
    function CheckDevDataFormSubmit(event) {
        //Get Credit Score
        apiService.getCreditScore(apiService.generatePersonData());
        apiService.collectFormData();

        console.log(apiService.formData);
    }

    $('#checkData').on('click', CheckDevDataFormSubmit);
    // END REMOVER AFTER COMPLETE
})(jQuery);